<template>
  <div class="animated fadeIn">
    <loading v-if="vLoading" />
    <v-col lg="12" class="ml-auto"></v-col>
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['ctrl' + 'q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <v-btn elevation="6" outlined small>S</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          ذخیره پیش‌نویس <br /><br />
          <v-btn elevation="6" outlined small>P</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          نسخه چاپی استعلام <br /><br />
          <v-btn elevation="6" outlined small>q</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          بروزرسانی موجودی <br /><br />
          <v-btn elevation="6" outlined small>d</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          اعمال قیمت‌های پیش‌بینی شده <br /><br />
          <v-btn elevation="6" outlined small>Shift</v-btn> ورود به حالت تعیین
          قیمت و بالعکس <br /><br />
          <v-btn elevation="6" outlined small>+</v-btn> افزودن محصول جدید
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-dialog v-model="analyzeOneItemModal" width="700">
      <v-card>
        <v-card-title>
          <h4>بررسی موجودی در انبار</h4>
          <p>
            این ابزار میتواند محصول وارد شده را به جزییات تقسیم کند و موجودی هر
            کدام را در انبار چک کند. <br />
            هدف از این ابزار، بررسی صحت اقلام وارد شده از نظر استاندارد است.
          </p>
        </v-card-title>
        <v-card-text>
          <b-table
            responsive
            small
            bordered
            show-empty
            :items="analyzedSelectedItems"
            :fields="warehouseSingleFields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="isBusySingleWarehouse"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
            <template v-slot:cell(inventory)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
                <span v-if="data.item.count">
                  <br />
                  {{ data.item.count }}
                </span>
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn outlined small @click="analyzeOneItemModal = false"
            >بستن</v-btn
          >
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <b-tabs pills card content-class="mt-3">
      <b-tab
        v-if="role == 'ceo' || role == 'Manager' || role == 'salesManager'"
        :title="orderInfo.status"
        active
      >
        <b-card>
          <template v-slot:header>
            <v-row :class="customer.customer_priority">
              <v-col cols="7" class="mt-4">
                <h4>کد پرونده: {{ orderInfo.orderCode }}</h4>

                <h5>نام مشتری: {{ orderInfo.customerName }}</h5>
                <h5>رتبه مشتری: {{ customer.customer_priority }}</h5>
                <h5>شماره درخواست مشتری: {{ orderInfo.originalRequestId }}</h5>
                <h5>کارشناس مشتری: {{ orderInfo.contactName }}</h5>
                <h5>
                  نوع استعلام:
                  {{
                    orderTypes.filter((x) => x.value == orderInfo.orderType)[0]
                      .text
                  }}
                </h5>
              </v-col>
              <v-col cols="5" class="mt-4">
                <v-col>
                  <v-row>
                    <v-col>
                      <h4>وضعیت پرونده: {{ orderInfo.status }}</h4>
                      <h5>تاریخ ثبت استعلام: {{ orderInfo.registerDate }}</h5>
                      <h5>ثبت اولیه توسط: {{ orderInfo.ownerName }}</h5>
                      <h5>
                        کارشناس بازرگانی:
                        {{ orderInfo.assigneeName }}
                      </h5>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <b-btn
                  variant="warning"
                  class="mr-1"
                  @click="draft()"
                  v-shortkey.once="['ctrl' + 's']"
                  @shortkey="draft()"
                  >ذخیره پیش‌نویس</b-btn
                >
                <b-btn
                  variant="dark"
                  class="mr-1"
                  @click="goToPrintPreview('full')"
                  v-shortkey.once="['ctrl' + 'p']"
                  @shortkey="goToPrintPreview('full')"
                  >نسخه چاپی استعلام</b-btn
                >
              </v-col>
              <v-col cols="6"></v-col>
              <v-col cols="3">
                <b-btn
                  :variant="showBatchArea ? 'danger' : 'primary'"
                  class="mr-1 text-white"
                  @click="batchAdd()"
                  style="float: left"
                  >{{
                    showBatchArea ? "بستن باکس افزودن گروهی" : "++ افزودن گروهی"
                  }}</b-btn
                >
              </v-col>
            </v-row>
            <hr />
            <v-row>
              <v-col cols="3">
                <v-switch
                  v-model="hasCustomerIndex"
                  label="ردیف مشتری"
                ></v-switch>
              </v-col>
              <v-col cols="3">
                <v-switch
                  v-model="hasSizeStandard"
                  label="استاندارد ابعاد"
                ></v-switch>
              </v-col>
              <v-col cols="3">
                <v-switch
                  v-model="onlyChangePrice"
                  label="فقط تغییر قیمت"
                ></v-switch>
                <b-btn
                  hidden
                  @click="onlyChangePrice = !onlyChangePrice"
                  v-shortkey.once="['shift']"
                  @shortkey="onlyChangePrice = !onlyChangePrice"
                />
              </v-col>
              <v-col
                cols="3"
                v-if="
                  role == 'Manager' || role == 'ceo' || role == 'salesManager'
                "
              >
                <b-btn
                  variant="success"
                  class="mr-1"
                  style="float: left"
                  @click="importPrpposePrice()"
                  v-shortkey.once="['ctrl' + 'd']"
                  @shortkey="importPrpposePrice()"
                  >اعمال قیمت‌های پیش‌بینی شده</b-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <b-form-select
                  :options="formTemplates"
                  v-model="formTemplate"
                />
              </v-col>
              <v-col cols="6">
                <b-form-select
                  :options="measurementUnits"
                  v-model="measurementUnit"
                />
              </v-col>
            </v-row>
          </template>
          <br />
          <v-row v-show="showBatchArea">
            <v-col cols="1"></v-col>
            <v-col cols="10">
              <b-card class="shadow p-3 mb-5 bg-white rounded">
                <b-textarea
                  type="text"
                  rows="6"
                  max-rows="10"
                  v-model="batchText"
                  placeholder="لطفا داده‌ها را از اکسل کپی کنید و دکمه تحلیل را بزنید. سپس از جدول حاصل میتوانید المان‌های مورد نظر را به جدول اصلی بیافزایید."
                />
                <br />
                <v-row>
                  <b-btn
                    variant="success"
                    class="mr-1"
                    @click="analyzeBatch()"
                    style="float: left"
                    >تحلیل</b-btn
                  >
                  <b-btn
                    variant="danger"
                    class="mr-1"
                    @click="delAnalyzeBatch()"
                    style="float: left"
                    >حذف نتایج</b-btn
                  >
                </v-row>
              </b-card>
              <b-card
                v-if="showBatchTable"
                class="shadow p-3 mb-5 bg-white rounded"
              >
                <b-table
                  responsive
                  v-if="showBatchTable"
                  show-empty
                  :items="batchData"
                  :fields="fieldsHistory"
                  empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  striped
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div>
                      <b-btn
                        variant="danger"
                        class="mr-2"
                        @click="delBatch(data.index)"
                        >x</b-btn
                      >
                    </div>
                  </template>
                  <template v-slot:cell(operation)="data">
                    <div style="text-align: center; vertical-align: middle">
                      <b-btn
                        variant="success"
                        class="mr-1"
                        @click="addItem(data.item)"
                        >افزودن</b-btn
                      >
                    </div>
                  </template>
                  <template v-slot:cell(perPrice)="data">{{
                    data.item.perPrice
                      ? Number(data.item.perPrice).toLocaleString()
                      : 0
                  }}</template>
                  <template v-slot:cell(totalPrice)="data">{{
                    data.item.perPrice * data.item.number
                      ? (data.item.perPrice * data.item.number).toLocaleString()
                      : 0
                  }}</template>

                  <div slot="table-busy" class="text-center text-danger my-2">
                    <strong>در حال بارگذاری...</strong>
                    <br />
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </b-table>
                <b-btn
                  variant="success"
                  class="mr-1"
                  style="float: left"
                  @click="doBatchAdd()"
                  >افزودن همه</b-btn
                >
              </b-card>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>

          <b-card
            class="shadow mb-5 bg-white rounded"
            header-bg-variant="primary"
            header-text-variant="white"
          >
            <template v-slot:header>
              <v-row>
                <v-col cols="4">
                  <h6 style="display: inline">صدور استعلام</h6>
                </v-col>
                <!-- <v-col cols="2">
                  <b-form-select
                    :options="currencyOptions"
                    v-model="currency"
                  />
                </v-col> -->
              </v-row>
            </template>

            <v-row class="mb-3 item-ckeditor">
              <v-col cols="10">
                <ckeditor
                  v-if="!showCustomerTerms"
                  :editor="editor"
                  :config="editorConfig"
                  v-model="newInfo.customerTerms"
                  @input="updateCustomerTerms"
                ></ckeditor>

                <div
                  v-if="showCustomerTerms"
                  v-html="orderInfo.customerTerms"
                  style="border: 1px solid black"
                  class="p-1 rounded"
                />
              </v-col>
              <v-col cols="2">
                <b-btn
                  variant="warning"
                  class="mr-1"
                  style="float: left"
                  @click="handleButtonClick"
                  >{{
                    showCustomerTerms ? "ویرایش متن بالا" : "ثبت تغییرات"
                  }}</b-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5">
                <v-text-field
                  type="text"
                  label="پیدا کن"
                  v-model="bulkEditFrom"
                  dense
                  outlined
                >
                </v-text-field
              ></v-col>
              <v-col cols="5"
                ><v-text-field
                  type="text"
                  label="جایگزین کن"
                  v-model="bulkEditTo"
                  dense
                  outlined
                ></v-text-field
              ></v-col>
              <v-col cols="2"
                ><b-btn
                  variant="primary"
                  class="mr-1"
                  style="float: left"
                  @click="doBulkEdit()"
                  >جایگزینی</b-btn
                ></v-col
              >
            </v-row>
            <v-row>
              جایگزینی در ستون‌های زیر انجام شود:
              <v-switch
                v-for="field in replaceFields"
                :key="field.key"
                v-model="field.value"
                :label="field.label"
                class="mx-2"
              ></v-switch>
            </v-row>
            <b-table
              small
              responsive
              show-empty
              :items="filtered"
              :fields="myFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="table table-secondary"
            >
              <template v-slot:head()="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma;
                  "
                >
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma;
                  "
                >
                  {{ data.value }}
                </div>
              </template>
              <template slot="top-row">
                <td v-for="field in myFields" :key="field.key">
                  <b-form-input
                    v-if="
                      field.label != '#' &&
                      field.key != 'operation' &&
                      field.key != 'selected'
                    "
                    v-model="filters[field.key]"
                    :placeholder="field.label"
                  ></b-form-input>
                  <p v-else-if="field.key == 'operation'">
                    <b-btn
                      variant="warning"
                      class="mr-2"
                      @click="getAllPrices()"
                      >$$</b-btn
                    >
                  </p>
                  <b-btn
                    v-else-if="field.key == 'selected'"
                    variant="dark"
                    class="m-1"
                    @click="toggleSelectAll()"
                    >همه/هیچ</b-btn
                  >

                  <p v-else-if="field.label == '#'">
                    <!-- <b-btn
                      :disabled="selectedItems.reduce((a, b) => a + b) < 2"
                      variant="dark"
                      class="mr-2"
                      @click="editSelected()"
                      ><i class="fa fa-edit"> </i
                    ></b-btn> -->
                  </p>
                </td>
              </template>
              <template v-slot:cell(index)="data">
                <div
                  style="
                    text-align: center;
                    vertical-align: middle;
                    font-family: Tahoma;
                  "
                >
                  {{ data.index + 1 }}
                  <br />
                  <!-- <b-form-checkbox
                    v-model="selectedItems[data.index]"
                  ></b-form-checkbox> -->
                </div>
              </template>
              <template v-slot:cell(selected)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  <b-form-checkbox
                    :disabled="onlyChangePrice"
                    v-model="data.item.selected"
                    @change="syncUpdateTable()"
                  ></b-form-checkbox>
                </div>
              </template>
              <template v-slot:cell(customerIndex)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  <b-form-input
                    :disabled="onlyChangePrice"
                    v-model="data.item.customerIndex"
                    type="text"
                  ></b-form-input>
                </div>
              </template>
              <template v-slot:cell(operation)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  <b-btn
                    variant="danger"
                    class="mr-2"
                    :disabled="onlyChangePrice"
                    @click="delOffer(data.index)"
                    >x</b-btn
                  >
                  <b-btn
                    variant="success"
                    class="mr-2"
                    :disabled="onlyChangePrice"
                    @click="copyItem(data.item, data.index)"
                    >کپی</b-btn
                  >
                  <b-btn
                    variant="warning"
                    class="mr-2"
                    :disabled="onlyChangePrice"
                    @click="getPrice(data.item)"
                    >$</b-btn
                  >
                  <b-btn
                    variant="warning"
                    class="mr-2"
                    @click="analyzeSingleItem(data.item)"
                    :disabled="onlyChangePrice || isBusySingleWarehouse"
                    >تحلیل</b-btn
                  >
                  <b-btn
                    v-if="
                      role == 'Manager' ||
                      role == 'ceo' ||
                      role == 'salesManager'
                    "
                    variant="success"
                    class="mr-2"
                    :disabled="onlyChangePrice"
                    @click="importPrpposePriceIndex(data.index)"
                    >قیمت پیشنهادی</b-btn
                  >
                </div>
              </template>

              <template v-slot:cell(totalPrice)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  {{
                    data.item.perPrice * data.item.number
                      ? (data.item.perPrice * data.item.number).toLocaleString()
                      : 0
                  }}
                </div>
              </template>

              <template v-slot:cell(proposePerPrice)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  {{
                    data.item.proposePerPrice
                      ? data.item.proposePerPrice.toLocaleString()
                      : 0
                  }}
                </div>
              </template>

              <template v-slot:cell(perPrice)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  <vuetify-money
                    v-model="data.item.perPrice"
                    :valueWhenIsEmpty="valueWhenIsEmpty"
                    :options="perPriceOptions"
                    type="number"
                    outlined
                    dense
                  />
                  <br />
                  <!-- <span>{{ sarmadNumber2(data.item.perPrice) }}</span> -->
                </div>
              </template>

              <template v-slot:cell(number)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  <v-text-field
                    v-model="data.item.number"
                    :disabled="onlyChangePrice"
                    type="number"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </template>

              <template v-slot:cell(length)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  <b-form-textarea
                    v-model="data.item.length"
                    :disabled="onlyChangePrice"
                    type="text"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
              </template>
              <template v-slot:cell(diameter)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  <b-form-textarea
                    v-model="data.item.diameter"
                    :disabled="onlyChangePrice"
                    type="text"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
              </template>
              <template v-slot:cell(dimensionStandard)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  <b-form-textarea
                    v-model="data.item.dimensionStandard"
                    :disabled="onlyChangePrice"
                    type="text"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
              </template>
              <template v-slot:cell(cover)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  <b-form-textarea
                    v-model="data.item.cover"
                    :disabled="onlyChangePrice"
                    type="text"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
              </template>
              <template v-slot:cell(details)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  <b-form-textarea
                    v-model="data.item.details"
                    :disabled="onlyChangePrice"
                    type="text"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
              </template>
              <template v-slot:cell(material)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  <b-form-textarea
                    v-model="data.item.material"
                    :disabled="onlyChangePrice"
                    type="text"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
              </template>
              <template v-slot:cell(description)="data">
                <div dir="ltr" style="font-family: Tahoma">
                  <b-form-textarea
                    v-model="data.item.description"
                    :disabled="onlyChangePrice"
                    type="text"
                    rows="6"
                    max-rows="6"
                  ></b-form-textarea>
                </div>
              </template>
            </b-table>
            <v-row>
              <b-table
                responsive
                small
                show-empty
                :items="updateAllItems"
                :fields="
                  myFields
                    .filter((x) => x.key != 'perPrice')
                    .filter((x) => x.key != 'totalPrice')
                "
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
                :busy="updateTableBusy"
              >
                <template v-slot:head()="data">
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      font-family: Tahoma;
                    "
                  >
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell(customerIndex)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-input
                      v-model="data.item.customerIndex"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(selected)="data">
                  <div dir="rtl" style="font-family: Tahoma">
                    {{ filtered.filter((x) => x.selected).length }}
                    قلم انتخاب شده است
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-btn
                      variant="danger"
                      class="m-1"
                      @click="bulkUpdate()"
                      :disabled="!filtered.filter((x) => x.selected).length"
                      >آپدیت</b-btn
                    >
                  </div>
                </template>

                <template v-slot:cell(number)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <v-text-field
                      v-model="data.item.number"
                      type="number"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                </template>

                <template v-slot:cell(length)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.length"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(details)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.details"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(diameter)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.diameter"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(dimensionStandard)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.dimensionStandard"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(cover)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.cover"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(material)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.material"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(description)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.description"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
              </b-table>
            </v-row>
            <v-row class="mb-3">
              <v-col cols="5"
                >قیمت اقلام:
                {{
                  orderInfo.orderItems.length > 0
                    ? sarmadNumber2(
                        orderInfo.orderItems
                          .map(
                            (x) =>
                              (x.perPrice
                                ? String(x.perPrice).replace(/\s/g, "")
                                : 0) *
                              (x.number
                                ? String(x.number).replace(/\s/g, "")
                                : 0)
                          )
                          .reduce((a, b) => a + b)
                      )
                    : "--"
                }}
                {{ currency }}
              </v-col>
              <v-col cols="1"></v-col>
              <v-col cols="2">واحد پول:</v-col>
              <v-col cols="3">
                <b-form-select :options="currencyOptions" v-model="currency" />
              </v-col>
            </v-row>
            <v-row class="mb-3">
              <v-col cols="2">درصد تغییر قیمت:‌</v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="multiplier"
                  type="number"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <b-btn variant="warning" @click="multiply()">اعمال</b-btn>
              </v-col>

              <v-col cols="1"></v-col>
              <v-col cols="2">درصد تغییر واحد:‌</v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="multiplierCount"
                  type="number"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="1">
                <b-btn variant="warning" @click="multiplyCount()">اعمال</b-btn>
              </v-col>
            </v-row>
            <v-row class="mb-3">
              <v-col cols="2">
                <b-btn
                  class="text-white"
                  :disabled="!orderInfo.orderItems.length"
                  variant="danger"
                  @click="delAll()"
                  >حذف همه اقلام</b-btn
                >
              </v-col>
              <v-col cols="7"></v-col>
              <v-col cols="3">
                <b-btn
                  class="text-white"
                  variant="success"
                  @click="addOffer()"
                  v-shortkey.once="['+']"
                  @shortkey="addOffer()"
                  style="float: left"
                  >+ افزودن محصول</b-btn
                >
              </v-col>
            </v-row>
            <table border="1px solid" width="100%" style="text-align: center">
              <tr>
                <th class="py-2">قیمت اقلام</th>
                <th>
                  {{
                    orderInfo.orderItems.length > 0
                      ? sarmadNumber2(
                          orderInfo.orderItems
                            .map((x) =>
                              parseInt(
                                x.number
                                  ? String(x.number).replace(/\s/g, "")
                                  : 0
                              )
                            )
                            .reduce((a, b) => a + b)
                        )
                      : "--"
                  }}
                  قلم
                </th>
                <th>
                  {{
                    orderInfo.orderItems.length > 0
                      ? sarmadNumber2(
                          orderInfo.orderItems
                            .map(
                              (x) =>
                                (x.perPrice
                                  ? String(x.perPrice).replace(/\s/g, "")
                                  : 0) *
                                (x.number
                                  ? String(x.number).replace(/\s/g, "")
                                  : 0)
                            )
                            .reduce((a, b) => a + b)
                        )
                      : "--"
                  }}
                  {{ currency }}
                </th>
              </tr>
              <tr>
                <td>هزینه بسته‌بندی</td>
                <td class="px-5">
                  <vuetify-money
                    v-model="packagingCost"
                    :valueWhenIsEmpty="valueWhenIsEmpty"
                    :options="perPriceOptions"
                    type="number"
                  />
                </td>
                <td>
                  {{
                    packagingCost
                      ? parseFloat(packagingCost).toLocaleString()
                      : 0
                  }}
                  {{ currency }}
                </td>
              </tr>
              <tr>
                <td>هزینه حمل</td>
                <td class="px-5">
                  <vuetify-money
                    v-model="transportCost"
                    :valueWhenIsEmpty="valueWhenIsEmpty"
                    :options="perPriceOptions"
                    type="number"
                  />
                </td>
                <td>
                  {{
                    transportCost
                      ? parseFloat(transportCost).toLocaleString()
                      : 0
                  }}
                  {{ currency }}
                </td>
              </tr>
              <tr>
                <td>هزینه بازرسی شخص ثالث</td>
                <td class="px-5">
                  <vuetify-money
                    v-model="personCost"
                    :valueWhenIsEmpty="valueWhenIsEmpty"
                    :options="perPriceOptions"
                    type="number"
                  />
                </td>
                <td>
                  {{ personCost ? parseFloat(personCost).toLocaleString() : 0 }}
                  {{ currency }}
                </td>
              </tr>
              <tr>
                <td>هزینه پوشش دهی (%)</td>
                <td class="px-5">
                  <vuetify-money
                    v-model="coatingCost"
                    :valueWhenIsEmpty="valueWhenIsEmpty"
                    :options="options"
                    type="number"
                  />
                </td>
                <td>
                  {{
                    orderInfo.orderItems.length > 0
                      ? sarmadNumber2(
                          orderInfo.orderItems
                            .map(
                              (x) =>
                                (x.perPrice
                                  ? x.perPrice.toString().replace(/\s/g, "")
                                  : 0) *
                                (x.number
                                  ? x.number.toString().replace(/\s/g, "")
                                  : 0)
                            )
                            .reduce((a, b) => a + b) *
                            (coatingCost / 100)
                        )
                      : "--"
                  }}
                  {{ currency }}
                </td>
              </tr>
              <tr>
                <td>هزینه تست و صدور گواهینامه</td>
                <td class="px-5">
                  <vuetify-money
                    v-model="certificationCost"
                    :valueWhenIsEmpty="valueWhenIsEmpty"
                    :options="perPriceOptions"
                    type="number"
                  />
                </td>
                <td>
                  {{
                    certificationCost
                      ? parseFloat(certificationCost).toLocaleString()
                      : 0
                  }}
                  {{ currency }}
                </td>
              </tr>
              <tr>
                <td>سایر هزینه‌ها</td>
                <td class="px-5">
                  <vuetify-money
                    v-model="otherCost"
                    :valueWhenIsEmpty="valueWhenIsEmpty"
                    :options="perPriceOptions"
                    type="number"
                  />
                </td>
                <td>
                  {{ otherCost ? parseFloat(otherCost).toLocaleString() : 0 }}
                  {{ currency }}
                </td>
              </tr>
              <tr>
                <td>تخفیف {{ currency }}ی</td>
                <td class="px-5">
                  <vuetify-money
                    v-model="discount"
                    :valueWhenIsEmpty="valueWhenIsEmpty"
                    :options="perPriceOptions"
                    type="number"
                  />
                </td>
                <td>
                  {{ discount ? parseFloat(discount).toLocaleString() : 0 }}
                  {{ currency }}
                </td>
              </tr>
              <tr
                v-if="
                  discount +
                  packagingCost +
                  transportCost +
                  personCost +
                  certificationCost +
                  otherCost
                "
              >
                <th class="py-2">قیمت کل بدون مالیات</th>
                <th>
                  {{
                    orderInfo.orderItems.length > 0
                      ? sarmadNumber2(
                          orderInfo.orderItems
                            .map((x) =>
                              parseInt(
                                x.number
                                  ? String(x.number).replace(/\s/g, "")
                                  : 0
                              )
                            )
                            .reduce((a, b) => a + b)
                        )
                      : "--"
                  }}
                  قلم
                </th>
                <th>
                  {{
                    totalPriceVatExcluded(
                      orderInfo.orderItems,
                      discount,
                      packagingCost,
                      transportCost,
                      personCost,
                      certificationCost,
                      otherCost,
                      currency
                    )
                  }}
                </th>
              </tr>
              <tr>
                <td>مالیات بر ارزش افزوده (%)</td>
                <td class="px-5">
                  <vuetify-money
                    v-model="orderVat"
                    :valueWhenIsEmpty="valueWhenIsEmpty"
                    :options="options"
                    type="number"
                  />
                </td>
                <td>
                  {{
                    totalVat(
                      orderInfo.orderItems,
                      discount,
                      packagingCost,
                      transportCost,
                      personCost,
                      certificationCost,
                      otherCost,
                      currency,
                      orderVat
                    )
                  }}
                </td>
              </tr>
              <tr>
                <th class="py-2">قیمت کل</th>
                <th>
                  {{
                    orderInfo.orderItems.length > 0
                      ? sarmadNumber2(
                          orderInfo.orderItems
                            .map((x) =>
                              parseInt(
                                x.number
                                  ? String(x.number).replace(/\s/g, "")
                                  : 0
                              )
                            )
                            .reduce((a, b) => a + b)
                        )
                      : "--"
                  }}
                  قلم
                </th>
                <th>
                  {{
                    totalPrice(
                      orderInfo.orderItems,
                      discount,
                      packagingCost,
                      transportCost,
                      personCost,
                      certificationCost,
                      otherCost,
                      currency,
                      orderVat
                    )
                  }}
                </th>
              </tr>
              <tr v-if="orderInfo.price">
                <th class="py-2"><em>آخرین قیمت اعلامی به مشتری</em></th>
                <td></td>
                <td>
                  <em>
                    {{
                      orderInfo.price ? orderInfo.price.toLocaleString() : 0
                    }}
                    {{ currency }}
                  </em>
                </td>
              </tr>
            </table>

            <hr />
            <v-row class="item-ckeditor">
              <v-col cols="10">
                <ckeditor
                  v-if="!showPurchaseTemrs"
                  :editor="editor"
                  :config="editorConfig"
                  v-model="newInfo.terms"
                  @input="updatePurchaseTerms"
                ></ckeditor>

                <div
                  v-if="showPurchaseTemrs"
                  v-html="orderInfo.terms"
                  style="border: 1px solid black"
                  class="p-1 rounded"
                />
              </v-col>
              <v-col cols="2">
                <b-btn
                  variant="warning"
                  class="mr-1"
                  style="float: left"
                  @click="handleButtonClickpurchas"
                  >{{
                    showPurchaseTemrs ? "ویرایش متن پایین" : "ثبت تغییرات"
                  }}</b-btn
                >
              </v-col>
            </v-row>
            <hr />
            <a
              class="btn btn-primary mr-1 ml-2 mb-3 mt-0 text-white"
              style="float: right"
              :href="'/' + role + '/order/' + $route.params.id"
              target="_blank"
            >
              مشاهده پرونده سفارش
            </a>

            <b-btn
              variant="warning"
              class="mr-1"
              style="float: left"
              @click="draft()"
              >ذخیره پیش‌نویس</b-btn
            >
            <b-btn
              variant="success"
              class="mr-1"
              style="float: left"
              @click="submitQuote()"
              v-if="orderInfo.status == 'ثبت استعلام'"
              :disabled="
                !(role == 'trade' || role == 'tradeHead' || role == 'Manager')
              "
              >ارسال به کارشناس فنی</b-btn
            >
            <b-btn
              variant="danger"
              class="mr-1"
              style="float: left"
              v-if="
                orderInfo.status == 'در انتظار بررسی فنی' ||
                orderInfo.status == 'تعیین قیمت توسط مدیر عامل'
              "
              :disabled="
                !(
                  role == 'tradeHead' ||
                  role == 'Manager' ||
                  role == 'salesManager'
                )
              "
              @click="sendBacktoTrade()"
              >برگشت به کارشناس بازرگانی</b-btn
            >
            <b-btn
              variant="success"
              class="mr-1"
              style="float: left"
              @click="sendToCeoPricing()"
              v-if="orderInfo.status == 'در انتظار بررسی فنی'"
              :disabled="
                !(
                  role == 'tradeHead' ||
                  role == 'Manager' ||
                  role == 'salesManager'
                )
              "
            >
              {{
                orderInfo.orderType == "full"
                  ? "ارسال به مدیر عامل جهت تعیین قیمت"
                  : "ارسال به مدیر عامل جهت امضا"
              }}
            </b-btn>

            <b-btn
              variant="success"
              class="mr-1"
              style="float: left"
              @click="submitQuotePrice()"
              v-if="orderInfo.status == 'تعیین قیمت توسط مدیر عامل'"
              :disabled="!(role == 'ceo' || role == 'Manager')"
              >ثبت اولیه تعیین قیمت</b-btn
            >

            <b-btn
              variant="success"
              class="mr-1"
              style="float: left"
              @click="sendToCeoSign()"
              v-if="orderInfo.status == 'بررسی تعیین قیمت توسط مدیر فروش'"
              :disabled="!(role == 'salesManager' || role == 'Manager')"
              >تایید تعیین قیمت - ارسال جهت امضا</b-btn
            >

            <b-btn
              variant="success"
              class="mr-1"
              style="float: left"
              @click="signQuote()"
              v-if="orderInfo.status == 'آماده برای امضا'"
              :disabled="!(role == 'ceo' || role == 'Manager')"
              >امضا</b-btn
            >
          </b-card>

          <b-card header-bg-variant="primary" header-text-variant="white">
            <template v-slot:header>
              <h6>تاریخچه اقلام مشتری</h6>
            </template>
            <br />
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <b-table
                responsive
                small
                bordered
                show-empty
                :items="filteredHistory"
                :fields="fieldsHistory2"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="currentPage"
                :per-page="perPage"
                :busy="isBusy"
                @filtered="onFiltered"
              >
                <template slot="top-row" slot-scope="{ fields }">
                  <td v-for="field in fieldsHistory2" :key="field.key">
                    <b-form-input
                      v-if="
                        field.label != '#' &&
                        field.key != 'operation' &&
                        field.key != 'totalPrice'
                      "
                      v-model="filtersHistory[field.key]"
                      :placeholder="field.label"
                    ></b-form-input>
                    <p v-if="field.key == 'operation'">جستجو</p>
                  </td>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + perPage * (currentPage - 1) + 1 }}
                  </div>
                </template>
                <template v-slot:cell(perPrice)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ sarmadNumberHistory(data.item) }}
                  </div>
                </template>
                <template v-slot:cell(orderCode)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a
                      :href="'/' + role + '/order/' + data.item.orderId"
                      target="_blank"
                      >{{ data.item.orderCode }}</a
                    >
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <b-btn
                      variant="success"
                      class="mr-1"
                      @click="addItem(data.item)"
                      >افزودن</b-btn
                    >
                  </div>
                </template>
                <!-- <template v-slot:cell(totalPrice)="data">{{(parseFloat(sarmadNumber(data.item.perPrice)) * parseInt(data.item.number)).toLocaleString()}}</template>
                <template v-slot:cell(number)="data">{{parseInt(data.item.number).toLocaleString()}}</template>
                <template v-slot:cell(perPrice)="data">{{sarmadNumber(data.item.perPrice).toLocaleString()}}</template>-->

                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
            </b-card>
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="filteredHistory.length"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-card>

          <b-card header-bg-variant="primary" header-text-variant="white">
            <template v-slot:header>
              <h6>موجودی انبار</h6>
              <b-btn
                variant="dark"
                class="mr-1 text-white"
                @click="getInventory()"
                v-shortkey.once="['ctrl' + 'i']"
                @shortkey="getInventory()"
                style="float: left"
                >بروزرسانی موجودی</b-btn
              >
            </template>
            <br />
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <b-table
                responsive
                small
                bordered
                show-empty
                :items="warehouseFilteredItems"
                :fields="warehouseFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="currentWarehousePage"
                :per-page="perPageWarehouse"
                :busy="isBusyWarehouse"
                @filtered="onFiltered"
              >
                <template slot="top-row" slot-scope="{ fields }">
                  <td v-for="field in warehouseFields" :key="field.key">
                    <b-form-input
                      v-if="field.label != '#' && field.key != 'operation'"
                      v-model="filtersWarehouse[field.key]"
                      :placeholder="field.label"
                    ></b-form-input>
                    <p v-if="field.key == 'operation'">جستجو</p>
                  </td>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{
                      data.index +
                      perPageWarehouse * (currentWarehousePage - 1) +
                      1
                    }}
                  </div>
                </template>
                <template v-slot:cell(inventory)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                    <span v-if="data.item.count">
                      <br />
                      {{ data.item.count }}
                    </span>
                  </div>
                </template>
                <!-- <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <b-btn
                      variant="success"
                      class="mr-1"
                      @click="addItem(data.item)"
                      >افزودن</b-btn
                    >
                  </div>
                </template> -->
                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
            </b-card>
            <b-pagination
              v-model="currentWarehousePage"
              :per-page="perPageWarehouse"
              :total-rows="totalRowsWarehouse"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-card>
          <br />
        </b-card>
      </b-tab>
      <b-tab
        v-if="role == 'trade' || role == 'tradeHead' || role == 'tradeIntern'"
        :title="orderInfo.status"
        active
      >
        <b-card>
          <template v-slot:header>
            <v-row :class="customer.customer_priority">
              <v-col cols="7" class="mt-4">
                <h4>کد پرونده: {{ orderInfo.orderCode }}</h4>

                <h5>نام مشتری: {{ orderInfo.customerName }}</h5>
                <h5>رتبه مشتری: {{ customer.customer_priority }}</h5>
                <h5>شماره درخواست مشتری: {{ orderInfo.originalRequestId }}</h5>
                <h5>کارشناس مشتری: {{ orderInfo.contactName }}</h5>
                <h5>
                  نوع استعلام:
                  {{
                    orderTypes.filter((x) => x.value == orderInfo.orderType)[0]
                      .text
                  }}
                </h5>
              </v-col>
              <v-col cols="5" class="mt-4">
                <v-col>
                  <v-row>
                    <v-col>
                      <h4>وضعیت پرونده: {{ orderInfo.status }}</h4>
                      <h5>تاریخ ثبت استعلام: {{ orderInfo.registerDate }}</h5>
                      <h5>ثبت اولیه توسط: {{ orderInfo.ownerName }}</h5>
                      <h5>
                        کارشناس بازرگانی:
                        {{ orderInfo.assigneeName }}
                      </h5>
                    </v-col>
                  </v-row>
                </v-col>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
                <b-btn variant="warning" class="mr-1" @click="draft()"
                  >ذخیره پیش‌نویس</b-btn
                >
                <b-btn
                  variant="dark"
                  class="mr-1"
                  @click="goToPrintPreview('technical')"
                  v-shortkey.once="['ctrl' + 'p']"
                  @shortkey="goToPrintPreview('technical')"
                  >نسخه چاپی استعلام</b-btn
                >
              </v-col>
              <v-col cols="6"> </v-col>
              <v-col cols="3">
                <b-btn
                  :variant="showBatchArea ? 'danger' : 'primary'"
                  class="mr-1 text-white"
                  @click="batchAdd()"
                  style="float: left"
                  >{{
                    showBatchArea ? "بستن باکس افزودن گروهی" : "++ افزودن گروهی"
                  }}</b-btn
                >
              </v-col>
            </v-row>
            <hr />

            <v-row>
              <v-col cols="3">
                <v-switch
                  v-model="hasCustomerIndex"
                  label="ردیف مشتری"
                ></v-switch>
              </v-col>
              <v-col cols="3">
                <v-switch
                  v-model="hasSizeStandard"
                  label="استاندارد ابعاد"
                ></v-switch>
              </v-col>
              <v-col cols="3">
                <b-form-select
                  :options="formTemplates"
                  v-model="formTemplate"
                />
              </v-col>
              <v-col cols="3">
                <b-form-select
                  :options="measurementUnits"
                  v-model="measurementUnit"
                />
              </v-col>
            </v-row>
          </template>
          <br />
          <v-row v-show="showBatchArea">
            <v-col cols="1"></v-col>
            <v-col cols="10">
              <b-card class="shadow p-3 mb-5 bg-white rounded">
                <b-textarea
                  type="text"
                  rows="6"
                  max-rows="10"
                  v-model="batchText"
                  placeholder="لطفا داده‌ها را از اکسل کپی کنید و دکمه تحلیل را بزنید. سپس از جدول حاصل میتوانید المان‌های مورد نظر را به جدول اصلی بیافزایید."
                />
                <br />
                <v-row>
                  <b-btn
                    variant="success"
                    class="mr-1"
                    @click="analyzeBatch()"
                    style="float: left"
                    >تحلیل</b-btn
                  >
                  <b-btn
                    variant="danger"
                    class="mr-1"
                    @click="delAnalyzeBatch()"
                    style="float: left"
                    >حذف نتایج</b-btn
                  >
                </v-row>
              </b-card>
              <b-card
                v-if="showBatchTable"
                class="shadow p-3 mb-5 bg-white rounded"
              >
                <b-table
                  responsive
                  v-if="showBatchTable"
                  show-empty
                  :items="batchData"
                  :fields="fieldsHistory"
                  empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  striped
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div>
                      <b-btn
                        variant="danger"
                        class="mr-2"
                        @click="delBatch(data.index)"
                        >x</b-btn
                      >
                    </div>
                  </template>
                  <template v-slot:cell(operation)="data">
                    <div style="text-align: center; vertical-align: middle">
                      <b-btn
                        variant="success"
                        class="mr-1"
                        @click="addItem(data.item)"
                        >افزودن</b-btn
                      >
                    </div>
                  </template>
                  <template v-slot:cell(totalPrice)="data">{{
                    data.item.perPrice * data.item.number
                      ? (data.item.perPrice * data.item.number).toLocaleString()
                      : 0
                  }}</template>

                  <div slot="table-busy" class="text-center text-danger my-2">
                    <strong>در حال بارگذاری...</strong>
                    <br />
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </b-table>
                <b-btn
                  variant="success"
                  class="mr-1"
                  style="float: left"
                  @click="doBatchAdd()"
                  >افزودن همه</b-btn
                >
              </b-card>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>

          <b-card
            class="shadow mb-5 bg-white rounded"
            header-bg-variant="primary"
            header-text-variant="white"
          >
            <template v-slot:header>
              <v-row>
                <v-col cols="6">
                  <h6 style="display: inline">صدور استعلام</h6>
                </v-col>
              </v-row>
            </template>

            <v-row class="mb-3 item-ckeditor">
              <v-col cols="10">
                <ckeditor
                  v-if="!showCustomerTerms"
                  :editor="editor"
                  :config="editorConfig"
                  v-model="newInfo.customerTerms"
                  @input="updateCustomerTerms"
                ></ckeditor>

                <div
                  v-if="showCustomerTerms"
                  v-html="orderInfo.customerTerms"
                  style="border: 1px solid black"
                  class="p-1 rounded"
                />
              </v-col>
              <v-col cols="2">
                <b-btn
                  variant="warning"
                  class="mr-1"
                  style="float: left"
                  @click="handleButtonClick"
                  >{{
                    showCustomerTerms ? "ویرایش متن بالا" : "ثبت تغییرات"
                  }}</b-btn
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="5">
                <v-text-field
                  type="text"
                  label="پیدا کن"
                  v-model="bulkEditFrom"
                  dense
                  outlined
                >
                </v-text-field
              ></v-col>
              <v-col cols="5"
                ><v-text-field
                  type="text"
                  label="جایگزین کن"
                  v-model="bulkEditTo"
                  dense
                  outlined
                ></v-text-field
              ></v-col>
              <v-col cols="2"
                ><b-btn
                  variant="primary"
                  class="mr-1"
                  style="float: left"
                  @click="doBulkEdit()"
                  >جایگزینی</b-btn
                ></v-col
              >
            </v-row>
            <v-row>
              جایگزینی در ستون‌های زیر انجام شود:
              <v-switch
                v-for="field in replaceFields"
                :key="field.key"
                v-model="field.value"
                :label="field.label"
                class="mx-2"
              ></v-switch>
            </v-row>
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <b-table
                responsive
                small
                show-empty
                :items="filtered"
                :fields="myFields"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      font-family: Tahoma;
                    "
                  >
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      font-family: Tahoma;
                    "
                  >
                    {{ data.value }}
                  </div>
                </template>
                <template slot="top-row" slot-scope="{ fields }">
                  <td v-for="field in myFields" :key="field.key">
                    <b-form-input
                      v-if="field.label != '#' && field.key != 'operation'"
                      v-model="filters[field.key]"
                      :placeholder="field.label"
                    ></b-form-input>
                    <p v-if="field.key == 'operation'">جستجو</p>
                  </td>
                </template>
                <template v-slot:cell(index)="data">
                  <div
                    style="
                      text-align: center;
                      vertical-align: middle;
                      font-family: Tahoma;
                    "
                  >
                    {{ data.index + 1 }}
                  </div>
                </template>
                <template v-slot:cell(customerIndex)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-input
                      v-model="data.item.customerIndex"
                      type="text"
                    ></b-form-input>
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-btn
                      variant="danger"
                      class="mr-2"
                      @click="delOffer(data.index)"
                      >x</b-btn
                    >
                    <b-btn
                      variant="success"
                      class="mr-2"
                      @click="copyItem(data.item, data.index)"
                      >کپی</b-btn
                    >
                    <b-btn
                      variant="warning"
                      class="mr-2"
                      @click="analyzeSingleItem(data.item)"
                      >تحلیل</b-btn
                    >
                    <b-btn
                      v-if="
                        role == 'Manager' ||
                        role == 'ceo' ||
                        role == 'salesManager'
                      "
                      variant="success"
                      class="mr-2"
                      :disabled="onlyChangePrice"
                      @click="importPrpposePriceIndex(data.index)"
                      >قیمت پیشنهادی</b-btn
                    >
                  </div>
                </template>

                <template v-slot:cell(totalPrice)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    {{
                      data.item.perPrice * data.item.number
                        ? (
                            data.item.perPrice * data.item.number
                          ).toLocaleString()
                        : 0
                    }}
                  </div>
                </template>

                <template v-slot:cell(proposePerPrice)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    {{
                      data.item.proposePerPrice
                        ? data.item.proposePerPrice.toLocaleString()
                        : 0
                    }}
                  </div>
                </template>

                <template v-slot:cell(perPrice)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <vuetify-money
                      v-model="data.item.perPrice"
                      :valueWhenIsEmpty="valueWhenIsEmpty"
                      :options="perPriceOptions"
                      type="number"
                      outlined
                      dense
                    />
                  </div>
                </template>

                <template v-slot:cell(number)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <v-text-field
                      v-model="data.item.number"
                      type="number"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                </template>

                <template v-slot:cell(length)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.length"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(details)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.details"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(diameter)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.diameter"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(dimensionStandard)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.dimensionStandard"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(cover)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.cover"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(material)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.material"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
                <template v-slot:cell(description)="data">
                  <div dir="ltr" style="font-family: Tahoma">
                    <b-form-textarea
                      v-model="data.item.description"
                      type="text"
                      rows="6"
                      max-rows="6"
                    ></b-form-textarea>
                  </div>
                </template>
              </b-table>
              <v-row class="mb-3">
                <v-col cols="5">
                  قیمت اقلام:
                  {{
                    orderInfo.orderItems.length > 0
                      ? parseFloat(
                          orderInfo.orderItems
                            .map(
                              (x) =>
                                (x.perPrice
                                  ? x.perPrice.toString().replace(/\s/g, "")
                                  : 0) *
                                (x.number
                                  ? x.number.toString().replace(/\s/g, "")
                                  : 0)
                            )
                            .reduce((a, b) => a + b)
                            .toFixed(
                              currencyOptions.filter(
                                (x) => x.value == currency
                              )[0].precision
                            )
                        ).toLocaleString()
                      : "--"
                  }}
                  {{ currency }}
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="2">واحد پول:</v-col>
                <v-col cols="3">
                  <b-form-select
                    :options="currencyOptions"
                    v-model="currency"
                  />
                </v-col>
              </v-row>
              <v-row class="mb-3">
                <v-col cols="2">درصد تغییر قیمت:‌</v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="multiplier"
                    type="number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <b-btn variant="warning" @click="multiply()">اعمال</b-btn>
                </v-col>

                <v-col cols="1"></v-col>
                <v-col cols="2">درصد تغییر واحد:‌</v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="multiplierCount"
                    type="number"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <b-btn variant="warning" @click="multiplyCount()"
                    >اعمال</b-btn
                  >
                </v-col>
              </v-row>
              <v-row class="mb-3">
                <v-col cols="2">
                  <b-btn
                    class="text-white"
                    :disabled="!orderInfo.orderItems.length"
                    variant="danger"
                    @click="delAll()"
                    >حذف همه اقلام</b-btn
                  >
                </v-col>
                <v-col cols="7"></v-col>
                <v-col cols="3">
                  <b-btn
                    variant="success"
                    @click="addOffer()"
                    style="float: left"
                    >+ افزودن محصول</b-btn
                  >
                </v-col>
              </v-row>
            </b-card>

            <v-row class="item-ckeditor">
              <v-col cols="10">
                <ckeditor
                  v-if="!showPurchaseTemrs"
                  :editor="editor"
                  :config="editorConfig"
                  v-model="newInfo.terms"
                  @input="updatePurchaseTerms"
                ></ckeditor>

                <div
                  v-if="showPurchaseTemrs"
                  v-html="orderInfo.terms"
                  style="border: 1px solid black"
                  class="p-1 rounded"
                />
              </v-col>
              <v-col cols="2">
                <b-btn
                  variant="warning"
                  class="mr-1"
                  style="float: left"
                  @click="handleButtonClickpurchas"
                  >{{
                    showPurchaseTemrs ? "ویرایش متن پایین" : "ثبت تغییرات"
                  }}</b-btn
                >
              </v-col>
            </v-row>
            <hr />
            <a
              class="btn btn-primary mr-1 ml-2 mb-3 mt-0 text-white"
              style="float: right"
              :href="'/' + role + '/order/' + $route.params.id"
              target="_blank"
            >
              مشاهده پرونده سفارش
            </a>
            <b-btn
              variant="warning"
              class="mr-1"
              style="float: left"
              @click="draft()"
              >ذخیره پیش‌نویس</b-btn
            >
            <b-btn
              variant="success"
              class="mr-1"
              style="float: left"
              @click="submitQuote()"
              v-if="orderInfo.status == 'ثبت استعلام'"
              :disabled="
                !(
                  role == 'trade' ||
                  role == 'tradeHead' ||
                  role == 'tradeIntern' ||
                  role == 'Manager'
                )
              "
              >ارسال به کارشناس فنی</b-btn
            >
            <b-btn
              variant="danger"
              class="mr-1"
              style="float: left"
              v-if="
                orderInfo.status == 'در انتظار بررسی فنی' ||
                orderInfo.status == 'تعیین قیمت توسط مدیر عامل'
              "
              :disabled="
                !(
                  role == 'tradeHead' ||
                  role == 'Manager' ||
                  role == 'salesManager'
                )
              "
              @click="sendBacktoTrade()"
              >برگشت به کارشناس بازرگانی</b-btn
            >
            <b-btn
              variant="success"
              class="mr-1"
              style="float: left"
              @click="sendToCeoPricing()"
              v-if="orderInfo.status == 'در انتظار بررسی فنی'"
              :disabled="
                !(
                  role == 'tradeHead' ||
                  role == 'Manager' ||
                  role == 'salesManager'
                )
              "
            >
              {{
                orderInfo.orderType == "full"
                  ? "ارسال به مدیر عامل جهت تعیین قیمت"
                  : "ارسال به مدیر عامل جهت امضا"
              }}
            </b-btn>

            <b-btn
              variant="success"
              class="mr-1"
              style="float: left"
              @click="submitQuotePrice()"
              v-if="orderInfo.status == 'تعیین قیمت توسط مدیر عامل'"
              :disabled="!(role == 'ceo' || role == 'Manager')"
              >ثبت اولیه تعیین قیمت</b-btn
            >

            <b-btn
              variant="success"
              class="mr-1"
              style="float: left"
              @click="sendToCeoSign()"
              v-if="orderInfo.status == 'بررسی تعیین قیمت توسط مدیر فروش'"
              :disabled="!(role == 'salesManager' || role == 'Manager')"
              >تایید تعیین قیمت - ارسال جهت امضا</b-btn
            >

            <b-btn
              variant="success"
              class="mr-1"
              style="float: left"
              @click="signQuote()"
              v-if="orderInfo.status == 'آماده برای امضا'"
              :disabled="!(role == 'ceo' || role == 'Manager')"
              >امضا</b-btn
            >
          </b-card>
          <b-card header-bg-variant="primary" header-text-variant="white">
            <template v-slot:header>
              <h6>تاریخچه مشتری</h6>
            </template>
            <br />
            <b-card class="shadow p-3 mb-5 bg-white rounded">
              <h6>
                <b-input-group size="md">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="جستجو"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                      variant="danger"
                      >حذف</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </h6>
              <b-table
                responsive
                small
                bordered
                show-empty
                :items="filteredHistory"
                :fields="fieldsHistory2"
                empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
                empty-text="رکوردی برای نمایش وجود ندارد"
                striped
                :current-page="currentPage"
                :per-page="perPage"
                :busy="isBusy"
                :filter="filter"
                @filtered="onFiltered"
              >
                <template slot="top-row" slot-scope="{ fields }">
                  <td v-for="field in fieldsHistory2" :key="field.key">
                    <b-form-input
                      v-if="
                        field.label != '#' &&
                        field.key != 'operation' &&
                        field.key != 'totalPrice'
                      "
                      v-model="filtersHistory[field.key]"
                      :placeholder="field.label"
                    ></b-form-input>
                    <p v-if="field.key == 'operation'">جستجو</p>
                  </td>
                </template>
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + perPage * (currentPage - 1) + 1 }}
                  </div>
                </template>
                <template v-slot:cell(orderCode)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <a
                      :href="'/' + role + '/order/' + data.item.orderId"
                      target="_blank"
                      >{{ data.item.orderCode }}</a
                    >
                  </div>
                </template>
                <template v-slot:cell(operation)="data">
                  <div style="text-align: center; vertical-align: middle">
                    <b-btn
                      variant="success"
                      class="mr-1"
                      @click="addItem(data.item)"
                      >افزودن</b-btn
                    >
                  </div>
                </template>
                <template v-slot:cell(totalPrice)="data">{{
                  sarmadNumber2(data.item.perPrice * parseInt(data.item.number))
                }}</template>
                <template v-slot:cell(number)="data">{{
                  data.item.number
                    ? parseInt(data.item.number).toLocaleString()
                    : 0
                }}</template>
                <template v-slot:cell(perPrice)="data">{{
                  sarmadNumber2(data.item.perPrice)
                }}</template>

                <div slot="table-busy" class="text-center text-danger my-2">
                  <strong>در حال بارگذاری...</strong>
                  <br />
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </b-table>
            </b-card>
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="filteredHistory.length"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-card>
          <br />
        </b-card>
      </b-tab>
      <b-tab title="فایل‌ها">
        <b-card
          header-bg-variant="secondray"
          header-text-variant="white"
          header="جدول فایل‌های آپلود شده"
          class="shadow p-3 mb-5 bg-white rounded"
        >
          <template v-slot:header>
            <h6>
              <b-input-group size="md">
                <b-form-input
                  v-model="filterFile"
                  type="search"
                  id="filterInput"
                  placeholder="جستجو"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    :disabled="!filterFile"
                    @click="filterFile = ''"
                    variant="danger"
                    >حذف</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </h6>
          </template>
          <b-table
            responsive
            :items="orderInfo.files"
            :fields="fieldsFile"
            show-empty
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="isBusyFile"
            :filter="filterFile"
          >
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage * (currentPage - 1) + 1 }}
              </div>
            </template>
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(download)="data">
              <div style="text-align: center; vertical-align: middle">
                <a class="btn btn-success" :href="data.item.url" role="button">
                  <i class="fa fa-download text-white" aria-hidden="true"></i>
                </a>
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </b-card>
      </b-tab>
      <b-tab title="یادداشت‌ها">
        <b-card header-bg-variant="primary" bg-variant="white">
          <template v-slot:header>
            <h5>
              کاربر گرامی، کلیه تغییراتی که روی کار انجام شده است در این بخش
              قابل مشاهده می‌باشد
            </h5>
          </template>
          <v-row class="mb-4"></v-row>
          <v-row v-for="item in journals" :key="item.id" class="mt-3">
            <v-col cols="1"></v-col>
            <v-col cols="1"></v-col>
            <v-col cols="10">
              <b-card
                text-variant="dark"
                header-bg-variant="primary"
                header-text-variant="light"
                style="max-width: 80%"
                class="shadow-lg p-0 mb-0 bg-white rounded h-100"
              >
                <template v-slot:header>
                  <v-row>
                    <v-col cols="6">
                      <h5>{{ item.name }}</h5>
                    </v-col>
                    <v-col cols="6">
                      <span style="float: left" dir="ltr">{{ item.date }}</span>
                    </v-col>
                  </v-row>
                </template>
                <b-card-text>
                  <div v-html="item.message"></div>
                  <br />
                </b-card-text>
              </b-card>
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </b-card>
      </b-tab>
      <b-tab v-if="role != 'tradeIntern'" title="اطلاعات مشتری">
        <b-card :class="customer.customer_priority" class="h-100">
          <b-row>
            <b-col cols="6">
              <div class="py-3 px-4">
                <h4>نام مشتری: {{ customer.name }}</h4>
                <hr />
                <h5>رتبه مشتری: {{ customer.customer_priority }}</h5>
                <h5>تعداد کل درخواست‌ها: {{ staticOrdersTotalRows }}</h5>
                <h5>تعداد رابطین: {{ staticAgentsTotalRows }}</h5>
              </div></b-col
            >
            <b-col cols="6">
              <div class="py-3 px-4">
                <h4>کد: {{ customer.customer_code }}</h4>
                <hr />
                <h5>استعلام‌های فعال: {{ customer.activeOrderNumber }}</h5>
                <h5>سفارش‌ها: {{ customer.factoryNumber }}</h5>
              </div></b-col
            >
          </b-row>
        </b-card>
        <b-card header-bg-variant="primary" header-text-variant="white">
          <template v-slot:header>
            <h5>استعلام‌های {{ customer.name }}</h5>
          </template>
          <br />
          <b-card class="shadow p-3 mb-5 bg-white rounded">
            <v-row class="p-0">
              <v-col class="pb-0 mt-3">
                <v-text-field
                  clearable
                  v-model="customerOrdersFilter"
                  placeholder="جستجو"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <br />
            <b-table
              responsive
              show-empty
              :items="customerOrders"
              :fields="customerOrdersFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPageOrder"
              :per-page="perPage"
              :busy="customerOrdersIsBusy"
              :filter="customerOrdersFilter"
              @filtered="onFilteredOrder"
              id="orders-list"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>

              <template v-slot:cell(progress)="data">
                <b-progress
                  :value="data.item.progress"
                  variant="success"
                  :striped="striped"
                  show-progress
                  animated
                ></b-progress>
              </template>
              <template v-slot:cell(orderCode)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="'/' + role + '/order/' + data.item.id"
                    target="_blank"
                    >{{ data.item.orderCode }}</a
                  >
                  <span v-if="data.item.isUrgent" class="text-danger">
                    <i class="mr-1 fa fa-exclamation-triangle"> </i>
                    فوری
                  </span>
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPageOrder - 1) }}
                </div>
              </template>
              <div slot="table-isBusy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <div class="d-flex justify-content-center">
              <h6>تعداد: {{ ordersTotalRows }}</h6>
            </div>
            <b-pagination
              v-model="currentPageOrder"
              :per-page="perPage"
              :total-rows="ordersTotalRows"
              align="center"
              size="md"
              class="my-0"
              aria-controls="orders-list"
            ></b-pagination>
          </b-card>
          <br />
        </b-card>
        <b-card header-bg-variant="primary" header-text-variant="white">
          <template v-slot:header>
            <v-row>
              <v-col>
                <h5 class="m-0 pt-1">رابط ها و مخاطبین {{ customer.name }}</h5>
              </v-col>
            </v-row>
          </template>
          <v-row class="p-0">
            <v-col class="pb-0 mt-3">
              <v-text-field
                clearable
                v-model="agentsFilter"
                placeholder="جستجو"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <br />
          <b-table
            responsive
            show-empty
            :items="agents"
            :fields="agentsFields"
            :current-page="currentPageContact"
            :per-page="perPage"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="agentsIsBusy"
            :filter="agentsFilter"
            @filtered="onFilteredContact"
            id="agents-table"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>

            <template v-slot:cell(progress)="data">
              <b-progress
                :value="data.item.progress"
                variant="success"
                :striped="striped"
                show-progress
                animated
              ></b-progress>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (currentPageContact - 1) }}
              </div>
            </template>
            <div slot="table-isBusy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <div class="d-flex justify-content-center">
            <h6>تعداد: {{ agentsTotalRows }}</h6>
          </div>
          <b-pagination
            v-model="currentPageContact"
            :total-rows="agentsTotalRows"
            :per-page="perPage"
            aria-controls="agents-tabel"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-card>
      </b-tab>
    </b-tabs>

    <v-dialog v-model="deleteDialog" max-width="500px" header-color="error">
      <v-card>
        <v-card-title>
          <h4>حذف کل موارد جدول</h4>
        </v-card-title>
        <v-card-text class="pb-0 pt-3 px-3">
          <v-container>
            <p>آیا از حذف کلیه محصولات وارد شده مطمئن هستید؟</p>
            <p style="font-weight: bold; color: red">
              این کار غیر قابل برگشت است!
            </p>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="deleteDialog = false"> لغو </v-btn>
          <v-btn class="text-white" color="red" @click="doDelAll()">
            حذف کن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editSelectedModal"
      max-width="500px"
      header-color="error"
    >
      <v-card>
        <v-card-title>
          <h4>ویرایش گروهی</h4>
        </v-card-title>
        <v-card-text class="pb-0 pt-3 px-3">
          <v-container>
            <p dir="ltr">
              {{
                orderInfo.orderItems.filter(
                  (item, index) => selectedItems[index]
                )
              }}
            </p>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="editSelectedModal = false">
            لغو
          </v-btn>
          <v-btn class="text-white" color="red" @click="doEditSelected()">
            حذف کن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import router from "../router";
import { CKEditor } from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import prices from "../mixins/prices";

export default {
  mixins: [prices],
  components: {
    CKEditor,
  },
  data: function () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "bold",
          "italic",
          "underline",
          "strikethrough",
          "subscript",
          "superscript",
          "fontColor",
        ],
        height: 200,
        language: "fa",
        contentsLangDirection: "rtl",
      },
      guide: false,
      selectedItems: [],
      editSelectedModal: false,
      bulkEditFrom: "",
      bulkEditTo: "",
      valueWhenIsEmpty: "0",
      options: {
        decimal: ".",
        thousands: ",",
        precision: 0,
        min: 0,
      },
      role: "",
      followContent: "",
      getContent: "",
      sendBackReason: "",
      rejectReason: "",
      items: [],
      filter: null,
      isBusy: false,
      isBusy2: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      batchText: "",
      batchData: [],
      itemsHistory: [],
      multiplier: 0,
      multiplierCount: 0,
      fields: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "proposePerPrice", label: "قیمت پیشنهادی" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fields2: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "proposePerPrice", label: "قیمت پیشنهادی" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsen: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "proposePerPrice", label: "Propose Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsen2: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "proposePerPrice", label: "Propose Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "description", label: "Description" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsCI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "proposePerPrice", label: "قیمت پیشنهادی" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fields2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "proposePerPrice", label: "قیمت پیشنهادی" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsenCI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "proposePerPrice", label: "Propose Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsen2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "proposePerPrice", label: "Propose Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      warehouseItems: [],
      warehouseFields: [
        { key: "index", label: "#" },
        { key: "inventory", label: "تعداد موجودی" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
      ],
      warehouseSingleFields: [
        { key: "index", label: "#" },
        { key: "inventory", label: "تعداد موجودی" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
      ],
      filtersWarehouse: [],
      currentWarehousePage: 1,
      perPageWarehouse: 25,
      totalRowsWarehouse: 0,
      isBusyWarehouse: false,
      isBusySingleWarehouse: false,
      analyzeOneItemModal: false,
      selectedItem: {},
      analyzedSelectedItems: [],
      fieldsHistory2: [
        { key: "index", label: "#" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "currency", label: "واحد پول" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "proposePerPrice", label: "قیمت پیشنهادی" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "orderCode", label: "کد استعلام" },
        { key: "operation", label: "پرونده استعلام" },
      ],
      formTemplates: [
        { value: "pk1", text: "الگوی PK1 فارسی" },
        { value: "pk2", text: "الگوی PK2 فارسی" },
        { value: "pken", text: "الگوی PK1 انگلیسی" },
        { value: "pken2", text: "الگوی PK2 انگلیسی" },
      ],
      measurementUnit: "",
      measurementUnits: [
        { value: "تعداد", text: "تعداد" },
        { value: "کیلوگرم", text: "کیلوگرم" },
        { value: "تن", text: "تن" },
      ],
      formTemplate: "",
      currencyOptions: [
        { value: "دلار", text: "دلار", precision: 2 },
        { value: "USD", text: "USD", precision: 2 },
        { value: "$", text: "$", precision: 2 },
        { value: "یورو", text: "یورو", precision: 2 },
        { value: "Euro", text: "Euro", precision: 2 },
        { value: "€", text: "€", precision: 2 },
        { value: "ریال", text: "ریال", precision: 0 },
        { value: "Rials", text: "Rials", precision: 0 },
        { value: "یوآن", text: "یوآن", precision: 2 },
        { value: "Yuan", text: "Yuan", precision: 2 },
        { value: "¥", text: "¥", precision: 2 },
        { value: "درهم", text: "درهم", precision: 2 },
      ],

      orderTypes: [
        { value: "full", text: "مالی" },
        { value: "technical", text: "فنی" },
      ],
      currency: "",
      hasCustomerIndex: false,
      hasSizeStandard: true,
      allOrders: [],

      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
          ],
        ],
        height: 200,
      },
      purchaseTerms: "",
      striped: true,
      showBatchArea: false,
      showBatchTable: false,
      showPurchaseTemrs: true,
      showCustomerTerms: true,
      customerInfo: {},
      orderInfo: {
        customerTerms: "",
        purchaseTerms: "",
      },
      newInfo: {
        customerTerms: "",
        purchaseTerms: "",
      },
      onlyChangePrice: false,
      filterFile: "",
      isBusyFile: false,
      itemsFile: [],
      fieldsFile: [
        { key: "index", label: "#" },
        { key: "date", label: "تاریخ آپلود" },
        { key: "name", label: "نام فایل" },
        // { key: "subject", label: "توضیحات" },
        { key: "uploaderName", label: "فرد بارگذاری کننده" },
        { key: "download", label: "دریافت" },
      ],
      journals: [],
      filters: {
        details: "",
        totalPrice: "",
        perPrice: "",
        number: "",
        length: "",
        diameter: "",
        dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        details: "",
        customerIndex: "",
        index: "",
        operation: "",
      },
      filtersHistory: {
        details: "",
        totalPrice: "",
        perPrice: "",
        number: "",
        length: "",
        diameter: "",
        dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        details: "",
        customerIndex: "",
        index: "",
        operation: "",
      },
      deleteDialog: false,
      sendMethods: [
        "پاکت دربسته",
        "ایمیل",
        "فاکس",
        "واتساپ",
        "سایر روش‌ها (در توضیحات ذکر شود)",
      ],
      sendMethod: "",
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: "",
      response: "none",
      responses: [
        {
          value: "none",
          text: "پاسخی دریافت نشده است",
          status: "در انتظار نظر مشتری",
        },
        {
          value: "yes",
          text: "با تعیین قیمت موافقم",
          status: "تایید تعیین قیمت توسط مشتری",
        },
        {
          value: "no",
          text: "با تعیین قیمت مخالفم",
          status: "رد تعیین قیمت توسط مشتری",
        },
        {
          value: "revision",
          text: "تعیین قیمت نیاز به بازبینی دارد",
          status: "بازبینی تعیین قیمت",
        },
      ],
      customerHistory: [],
      orderVat: 0,
      packagingCost: 0,
      transportCost: 0,
      personCost: 0,
      coatingCost: 0,
      otherCost: 0,
      certificationCost: 0,
      discount: 0,
      customerOrders: [],
      ordersTotalRows: 0,
      staticOrdersTotalRows: 0,
      agents: [],
      agentsTotalRows: 0,
      staticAgentsTotalRows: 0,
      customer: {},
      customerOrdersFields: [
        { key: "index", label: "ردیف" },
        { key: "orderCode", label: "کد استعلام" },
        { key: "originalRequestId", label: "شماره درخواست" },
        { key: "registerDate", label: "تاریخ" },
        { key: "status", label: "وضعیت" },
      ],
      customerOrdersIsBusy: true,
      customerOrdersFilter: null,
      currentPageOrder: 1,
      agentsFilter: null,
      agentsIsBusy: true,
      currentPageContact: 1,
      agentsFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام رابط" },
        { key: "internal", label: "داخلی" },
        { key: "role", label: "سمت" },
        { key: "phone", label: "تلفن" },
        { key: "phone2", label: "تلفن 2" },
        { key: "fax", label: "فاکس" },
        { key: "mobile", label: "موبایل" },
        { key: "email", label: "ایمیل" },
        { key: "address", label: "آدرس" },
        { key: "postalCode", label: "کد پستی" },
        // { key: "operation", label: "عملیات" },
      ],
      replaceFields: [
        { key: "details", label: "توضیحات تکمیلی", value: false },
        { key: "number", label: "واحد", value: false },
        { key: "length", label: "طول", value: false },
        { key: "diameter", label: "قطر", value: false },
        { key: "dimensionStandard", label: "استاندارد ابعاد", value: false },
        { key: "cover", label: "پوشش", value: false },
        { key: "material", label: "متریال", value: false },
        { key: "description", label: "شرح کالا", value: false },
      ],
      updateAllItems: [
        {
          details: "",
          number: "",
          length: "",
          diameter: "",
          dimensionStandard: "",
          cover: "",
          material: "",
          description: "",
        },
      ],
      updateTableBusy: false,
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    doBulkEdit() {
      var bulkEditFields = this.replaceFields.filter((x) => x.value);
      // bulkEditItems = JSON.stringify(this.orderInfo.orderItems);
      // bulkEditItems = bulkEditItems.replaceAll(
      //   this.bulkEditFrom,
      //   this.bulkEditTo
      // );
      // this.orderInfo.orderItems = JSON.parse(bulkEditItems);

      this.orderInfo.orderItems.forEach((item) => {
        bulkEditFields.forEach((element) => {
          item[element.key] = item[element.key].replaceAll(
            this.bulkEditFrom,
            this.bulkEditTo
          );
        });
      });
    },
    goToPrintPreview(type) {
      let routeData = this.$router.resolve({
        path:
          "/" +
          this.role +
          "/printPreview/" +
          type +
          "/" +
          this.$route.params.id,
      });
      window.open(routeData.href, "_blank");
    },
    onFilteredOrder(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.ordersTotalRows = filteredItems.length;
      this.currentPageOrder = 1;
    },
    onFilteredContact(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.agentsTotalRows = filteredItems.length;
      this.currentPageContact = 1;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredWarehouse(filteredItems) {
      this.totalRowsWarehouse = filteredItems.length;
      this.perPageWarehouse = 1;
    },
    sarmadNumber2(data) {
      if (data == "اشکالی در محاسبات وجود دارد. حاصل منفی شده است")
        return "اشکالی در محاسبات وجود دارد. حاصل منفی شده است";

      try {
        let temp1 = parseFloat(data).toFixed(
          this.currencyOptions.filter((x) => x.value == this.currency)[0]
            .precision
        );
        return parseFloat(temp1) ? parseFloat(temp1).toLocaleString() : "--";
      } catch (error) {
        return "--";
      }
    },
    getInventory() {
      this.isBusyWarehouse = true;
      this.warehouseItems = JSON.parse(
        JSON.stringify(this.orderInfo.orderItems)
      );
      this.warehouseItems.forEach((item, index) => {
        item.index = index + 1;
      });
      this.analyzeAll();
    },
    analyzeAll() {
      var myAllItems = this.orderInfo.orderItems;
      myAllItems = myAllItems
        .map((x) => (x ? x.description.split("&") : []))
        .reduce((a, b) => a.concat(b), []);
      this.warehouseItems.forEach((item, index) => {
        this.analyzeItem(item, index);
      });

      setTimeout(() => {
        if (myAllItems.length == this.warehouseItems.length)
          this.getInventoryFinal();
        else this.analyzeAll();
      }, 100);
    },
    analyzeItem(item, index) {
      if (parseInt(item.index) == item.index) {
        var myNumber = item.number;
        var myLength = item.length;
        var myDiameter = item.diameter;
        var myCover = item.cover;
        var myCustomerIndex = item.customerIndex;
        var myIndex = item.index;
        var myDetails = item.details;
        try {
          {
            var myDescriptions = item.description.split("&");
            var myDimensionStandards = "";
            var myMaterials = "";
            if (this.formTemplate == "pk1") {
              myMaterials = item.material.split("&");
              if (this.hasSizeStandard) {
                myDimensionStandards = item.dimensionStandard.split("&");
              }
            } else {
              myDimensionStandards = "";
              myMaterials = "";
            }
            if (myDescriptions.length > 1) {
              try {
                myDescriptions.forEach((element, index2) => {
                  var finalDimensionStandards;
                  var finalMaterials;
                  var finalDescriptions;
                  var finalNumber = myNumber;
                  try {
                    finalDimensionStandards =
                      myDimensionStandards[index2].trim();
                  } catch (error) {
                    finalDimensionStandards = "";
                  }
                  try {
                    finalMaterials = myMaterials[index2].trim();
                  } catch (error) {
                    finalMaterials = "";
                  }
                  try {
                    finalDescriptions = myDescriptions[index2].trim();
                    if (!isNaN(finalDescriptions[0])) {
                      finalNumber = finalNumber * Number(finalDescriptions[0]);
                      finalDescriptions = finalDescriptions.substring(1).trim();
                      var descriptionLength = finalDescriptions.length;
                      if (finalDescriptions[descriptionLength - 1] == "S") {
                        finalDescriptions = finalDescriptions
                          .substring(0, descriptionLength - 1)
                          .trim();
                      }
                    }
                  } catch (error) {
                    console.log(error);
                    finalDescriptions = "";
                  }

                  this.warehouseItems.splice(index + index2 + 1, 0, {
                    number: finalNumber,
                    length: item.length,
                    diameter: item.diameter,
                    dimensionStandard: finalDimensionStandards,
                    cover: item.cover,
                    material: finalMaterials,
                    description: finalDescriptions,
                    details: item.details,
                    customerIndex: item.customerIndex,
                    index: parseInt(Number(item.index) * 10 + index2 + 1) / 10,
                  });
                });
              } catch (error) {
                console.log(error);
              }

              this.delWarehouseItem(index);
            }
          }
        } catch (error) {}
      }
    },
    analyzeSingleItem(item) {
      if (item.description && item.diameter) {
        this.isBusySingleWarehouse = true;
        this.selectedItem = item;
        this.analyzedSelectedItems = [];
        var myNumber = this.selectedItem.number;
        try {
          {
            var myDescriptions = this.selectedItem.description.split("&");
            var goalCount = myDescriptions.length;
            var myCount = 0;
            var myDimensionStandards = "";
            var myMaterials = "";
            try {
              if (this.formTemplate == "pk1") {
                myMaterials = this.selectedItem.material.split("&");
                if (this.hasSizeStandard) {
                  myDimensionStandards =
                    this.selectedItem.dimensionStandard.split("&");
                }
              } else {
                myDimensionStandards = "";
                myMaterials = "";
              }
            } catch (error) {
              myDimensionStandards = "";
              myMaterials = "";
            }
            try {
              myDescriptions.forEach((element, index) => {
                var finalDimensionStandards;
                var finalMaterials;
                var finalDescriptions;
                var finalNumber = myNumber;
                try {
                  finalDimensionStandards = myDimensionStandards[index].trim();
                } catch (error) {
                  finalDimensionStandards = "";
                }
                try {
                  finalMaterials = myMaterials[index].trim();
                } catch (error) {
                  finalMaterials = "";
                }
                try {
                  finalDescriptions = myDescriptions[index].trim();
                  if (!isNaN(finalDescriptions[0])) {
                    finalNumber = finalNumber * Number(finalDescriptions[0]);
                    finalDescriptions = finalDescriptions.substring(1).trim();
                    var descriptionLength = finalDescriptions.length;
                    if (finalDescriptions[descriptionLength - 1] == "S") {
                      finalDescriptions = finalDescriptions
                        .substring(0, descriptionLength - 1)
                        .trim();
                    }
                  }
                } catch (error) {
                  console.log(error);
                  finalDescriptions = "";
                }

                this.analyzedSelectedItems[index] = {
                  number: finalNumber,
                  length: this.selectedItem.length,
                  diameter: this.selectedItem.diameter,
                  dimensionStandard: finalDimensionStandards,
                  cover: this.selectedItem.cover,
                  material: finalMaterials,
                  description: finalDescriptions,
                  details: this.selectedItem.details,
                  customerIndex: this.selectedItem.customerIndex,
                  index: parseInt(1 * 10 + index + 1) / 10,
                };
                Axios.post(
                  this.baseUrl + "/ppkpms/office/warehouse/productStockNumber",
                  {
                    length: this.analyzedSelectedItems[index].length
                      ? this.analyzedSelectedItems[index].length
                          .replace(/\s+/g, " ")
                          .trim()
                      : "",
                    diameter: this.analyzedSelectedItems[index].diameter
                      ? this.analyzedSelectedItems[index].diameter
                          .replace(/\s+/g, " ")
                          .trim()
                      : "",
                    dimensionStandard: this.analyzedSelectedItems[index]
                      .dimensionStandard
                      ? this.analyzedSelectedItems[index].dimensionStandard
                          .replace(/\s+/g, " ")
                          .trim()
                      : "",
                    coating: this.analyzedSelectedItems[index].cover
                      ? this.analyzedSelectedItems[index].cover
                          .replace(/\s+/g, " ")
                          .trim()
                      : "",
                    material: this.analyzedSelectedItems[index].material
                      ? this.analyzedSelectedItems[index].material
                          .replace(/\s+/g, " ")
                          .trim()
                      : "",
                    name: this.analyzedSelectedItems[index].description
                      ? this.analyzedSelectedItems[index].description
                          .replace(/\s+/g, " ")
                          .trim()
                      : "",
                  },
                  {
                    headers: {
                      Authorization: "Bearer: " + localStorage.getItem("token"),
                    },
                  }
                )
                  .then((res) => {
                    if (res.status == 200) {
                      if (res.data.inventory == "-") {
                        this.analyzedSelectedItems[index].inventory = "-";
                      } else {
                        this.analyzedSelectedItems[index].inventory = Number(
                          res.data.inventory
                        ).toLocaleString();
                      }
                      if (res.data.count == "-") {
                        this.analyzedSelectedItems[index].count =
                          "کالایی پیدا نشد";
                      } else if (res.data.count == 0) {
                        data.this.analyzedSelectedItems[index].count ==
                          "کالایی پیدا نشد";
                      } else {
                        this.analyzedSelectedItems[index].count =
                          "از " + res.data.count + " مدل";
                      }
                      myCount++;
                      if (myCount == goalCount) {
                        this.isBusySingleWarehouse = false;
                        this.analyzeOneItemModal = true;
                      }
                    } else {
                      myCount++;
                      if (myCount == goalCount) {
                        this.isBusySingleWarehouse = false;
                        this.analyzeOneItemModal = true;
                      }
                      this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
                    }
                  })
                  .catch((err) => {
                    myCount++;
                    if (myCount == goalCount) {
                      this.isBusySingleWarehouse = false;
                      this.analyzeOneItemModal = true;
                    }
                    this.toast("خطا: " + err.response.data, "error");
                  });
              });
            } catch (error) {
              console.log(error);
            }
          }
        } catch (error) {
          console.log(error);
          this.isBusySingleWarehouse = false;
        }
      } else {
        this.toast("وارد کردن شرح و قطر برای تحلیل الزامی‌ست", "warning");
      }
    },
    delWarehouseItem(order) {
      this.warehouseItems.splice(order, 1);
    },
    getInventoryFinal() {
      var myCount = 0;
      this.warehouseItems.forEach((item) => {
        Axios.post(
          this.baseUrl + "/ppkpms/office/warehouse/productStockNumber",
          {
            length: item.length ? item.length.replace(/\s+/g, " ").trim() : "",
            diameter: item.diameter
              ? item.diameter.replace(/\s+/g, " ").trim()
              : "",
            dimensionStandard: item.dimensionStandard
              ? item.dimensionStandard.replace(/\s+/g, " ").trim()
              : "",
            coating: item.cover ? item.cover.replace(/\s+/g, " ").trim() : "",
            material: item.material
              ? item.material.replace(/\s+/g, " ").trim()
              : "",
            name: item.description
              ? item.description.replace(/\s+/g, " ").trim()
              : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              if (res.data.inventory == "-") {
                item.inventory = "-";
              } else {
                item.inventory = Number(res.data.inventory).toLocaleString();
              }
              if (res.data.count == "-") {
                item.count = "";
              } else if (res.data.count == 0 || res.data.count == 1) {
                data.item.count == "";
              } else {
                item.count = "از " + res.data.count + " مدل";
              }
              myCount++;
              if (myCount == this.warehouseItems.length)
                this.isBusyWarehouse = false;
            } else {
              myCount++;
              if (myCount == this.warehouseItems.length)
                this.isBusyWarehouse = false;
              this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
            }
          })
          .catch((err) => {
            myCount++;
            if (myCount == this.warehouseItems.length)
              this.isBusyWarehouse = false;
            this.toast("خطا: " + err.response.data, "error");
          });
      });
    },
    sarmadNumberHistory(data) {
      let myCurrency = data.currency
        ? data.currency == "-"
          ? "ریال"
          : data.currency
        : "ریال";
      try {
        let temp1 = parseFloat(data.perPrice).toFixed(
          this.currencyOptions.filter((x) => x.value == myCurrency)[0].precision
        );
        return parseFloat(temp1) ? parseFloat(temp1).toLocaleString() : "--";
      } catch (error) {
        return "---";
      }
    },
    sendToCeoPricing() {
      if (this.orderInfo.orderType == "full") {
        if (
          this.orderInfo.orderItems
            .map(
              (x) =>
                (x.perPrice ? x.perPrice.toString().replace(/\s/g, "") : 0) *
                (x.number ? x.number.toString().replace(/\s/g, "") : 0)
            )
            .reduce((a, b) => a + b) == 0
        )
          this.getAllPrices();
      }
      Axios.post(
        this.baseUrl + "/ppkpms/order/approveTechnicalQuote",
        {
          orderId: this.$route.params.id,
          productsTemplate: this.formTemplate,
          measurementUnit: this.measurementUnit,
          customerTerms: this.newInfo.customerTerms
            ? this.newInfo.customerTerms
            : this.orderInfo.customerTerms,
          terms: this.newInfo.terms ? this.newInfo.terms : this.purchaseTerms,
          orderItems: JSON.stringify(this.orderInfo.orderItems),
          hasCustomerIndex: this.hasCustomerIndex,
          hasSizeStandard: this.hasSizeStandard,
          orderVat: this.orderVat || 0,
          packagingCost: this.packagingCost || 0,
          transportCost: this.transportCost || 0,
          personCost: this.personCost || 0,
          coatingCost: this.coatingCost || 0,
          certificationCost: this.certificationCost || 0,
          otherCost: this.otherCost || 0,
          discount: this.discount || 0,
          currency: this.currency,
          // note:this.purchaseTerms
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            router.push("/" + this.role + "/dashboard/");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    submitQuote() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/submitQuote",
        {
          orderId: this.$route.params.id,
          productsTemplate: this.formTemplate,
          measurementUnit: this.measurementUnit,
          customerTerms: this.newInfo.customerTerms
            ? this.newInfo.customerTerms
            : this.orderInfo.customerTerms,
          terms: this.newInfo.terms ? this.newInfo.terms : this.purchaseTerms,
          orderItems: JSON.stringify(this.orderInfo.orderItems),
          hasCustomerIndex: this.hasCustomerIndex,
          hasSizeStandard: this.hasSizeStandard,
          orderVat: this.orderVat || 0,
          packagingCost: this.packagingCost || 0,
          transportCost: this.transportCost || 0,
          personCost: this.personCost || 0,
          certificationCost: this.certificationCost || 0,
          coatingCost: this.coatingCost || 0,
          otherCost: this.otherCost || 0,
          discount: this.discount || 0,
          currency: this.currency,
          // note:this.purchaseTerms
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            router.push("/" + this.role + "/dashboard/");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    sendToCeoSign() {
      if (this.checkSimilarPrices() != "OK") {
        this.toast(this.checkSimilarPrices(), "error");
      } else {
        Axios.post(
          this.baseUrl + "/ppkpms/order/sendToCeoSign",
          {
            orderId: this.$route.params.id,
            productsTemplate: this.formTemplate,
            measurementUnit: this.measurementUnit,
            customerTerms: this.newInfo.customerTerms
              ? this.newInfo.customerTerms
              : this.orderInfo.customerTerms,
            terms: this.newInfo.terms ? this.newInfo.terms : this.purchaseTerms,
            orderItems: JSON.stringify(this.orderInfo.orderItems),
            hasCustomerIndex: this.hasCustomerIndex,
            hasSizeStandard: this.hasSizeStandard,
            orderVat: this.orderVat || 0,
            packagingCost: this.packagingCost || 0,
            transportCost: this.transportCost || 0,
            personCost: this.personCost || 0,
            coatingCost: this.coatingCost || 0,
            certificationCost: this.certificationCost || 0,
            otherCost: this.otherCost || 0,
            discount: this.discount || 0,
            currency: this.currency,
            // note:this.purchaseTerms
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.toast("عملیات موفق", "success");
              router.push("/" + this.role + "/dashboard/");
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
          });
      }
    },
    signQuote() {
      if (this.checkSimilarPrices() != "OK") {
        this.toast(this.checkSimilarPrices(), "error");
      } else {
        Axios.post(
          this.baseUrl + "/ppkpms/order/signQuote",
          {
            orderId: this.$route.params.id,
            productsTemplate: this.formTemplate,
            measurementUnit: this.measurementUnit,
            customerTerms: this.newInfo.customerTerms
              ? this.newInfo.customerTerms
              : this.orderInfo.customerTerms,
            terms: this.newInfo.terms ? this.newInfo.terms : this.purchaseTerms,
            orderItems: JSON.stringify(this.orderInfo.orderItems),
            hasCustomerIndex: this.hasCustomerIndex,
            hasSizeStandard: this.hasSizeStandard,
            orderVat: this.orderVat || 0,
            packagingCost: this.packagingCost || 0,
            transportCost: this.transportCost || 0,
            personCost: this.personCost || 0,
            coatingCost: this.coatingCost || 0,
            certificationCost: this.certificationCost || 0,
            otherCost: this.otherCost || 0,
            discount: this.discount || 0,
            currency: this.currency,
            // note:this.purchaseTerms
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.toast("عملیات موفق", "success");
              router.push("/" + this.role + "/dashboard/");
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
          });
      }
    },
    showGetCustomerDialog() {
      this.getCustomerDialog = true;
    },
    showFollowCustomerDialog() {
      this.followCustomerDialog = true;
    },
    sendBacktoTrade() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/sendBacktoTrade",
        {
          orderId: this.$route.params.id,
          productsTemplate: this.formTemplate,
          measurementUnit: this.measurementUnit,
          customerTerms: this.newInfo.customerTerms
            ? this.newInfo.customerTerms
            : this.orderInfo.customerTerms,
          terms: this.newInfo.terms ? this.newInfo.terms : this.purchaseTerms,
          orderItems: JSON.stringify(this.orderInfo.orderItems),
          hasCustomerIndex: this.hasCustomerIndex,
          hasSizeStandard: this.hasSizeStandard,
          orderVat: this.orderVat || 0,
          packagingCost: this.packagingCost || 0,
          transportCost: this.transportCost || 0,
          personCost: this.personCost || 0,
          coatingCost: this.coatingCost || 0,
          certificationCost: this.certificationCost || 0,
          otherCost: this.otherCost || 0,
          discount: this.discount || 0,
          currency: this.currency,
          // note:this.purchaseTerms
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            router.push("/" + this.role + "/dashboard/");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    checkSimilarPrices() {
      this.vLoading = true;
      var errors = [];
      var compareFields = this.myFields;
      compareFields = compareFields.filter((x) => x.key != "perPrice");
      compareFields = compareFields.filter((x) => x.key != "proposePerPrice");
      compareFields = compareFields.filter((x) => x.key != "totalPrice");
      compareFields = compareFields.filter((x) => x.key != "operation");
      compareFields = compareFields.filter((x) => x.key != "details");
      compareFields = compareFields.filter((x) => x.key != "totalPrice");
      compareFields = compareFields.filter((x) => x.key != "number");
      compareFields = compareFields.filter((x) => x.key != "index");
      compareFields = compareFields.filter((x) => x.key != "customerIndex");
      compareFields = compareFields.filter((x) => x.key != "selected");

      this.orderInfo.orderItems.forEach((item) => {
        item.identifier = "";
        compareFields.forEach((field) => {
          item.identifier += item[field.key]
            ? item[field.key].toLowerCase().split(" ").join("")
            : "";
        });
      });

      var onlyIdentifiers = this.orderInfo.orderItems.map((x) => x.identifier);
      onlyIdentifiers = onlyIdentifiers.map((item, index) => {
        return {
          item: item,
          index: index,
        };
      });
      onlyIdentifiers.forEach((item, index) => {
        var similarItems = onlyIdentifiers.filter((x) => x.item == item.item);
        if (similarItems.length > 1) {
          var basePrice = Number(
            this.orderInfo.orderItems[similarItems[0].index].perPrice
          );
          similarItems.forEach((element) => {
            if (
              basePrice !=
              Number(this.orderInfo.orderItems[element.index].perPrice)
            )
              errors.push({
                firstOrderIndex: similarItems[0].index,
                firstItemPrice:
                  this.orderInfo.orderItems[similarItems[0].index].perPrice,
                secondOrderIndex: element.index,
                secondItemPrice:
                  this.orderInfo.orderItems[element.index].perPrice,
              });
          });
        }
      });

      this.vLoading = false;
      if (errors.length == 0) {
        return "OK";
      } else {
        var errorMessage = "";
        errorMessage +=
          "خطا: سطر " +
          Number(errors[0].firstOrderIndex + 1) +
          " و سطر " +
          Number(errors[0].secondOrderIndex + 1) +
          " دارای ویژگی‌های مشابه ولی قیمت متفاوت هستند";
        return errorMessage;
      }
    },
    submitQuotePrice() {
      if (this.checkSimilarPrices() != "OK") {
        this.toast(this.checkSimilarPrices(), "error");
      } else {
        Axios.post(
          this.baseUrl + "/ppkpms/order/submitQuotePrice",
          {
            orderId: this.$route.params.id,
            productsTemplate: this.formTemplate,
            measurementUnit: this.measurementUnit,
            customerTerms: this.newInfo.customerTerms
              ? this.newInfo.customerTerms
              : this.orderInfo.customerTerms,
            terms: this.newInfo.terms ? this.newInfo.terms : this.purchaseTerms,
            orderItems: JSON.stringify(this.orderInfo.orderItems),
            hasCustomerIndex: this.hasCustomerIndex,
            hasSizeStandard: this.hasSizeStandard,
            orderVat: this.orderVat || 0,
            packagingCost: this.packagingCost || 0,
            transportCost: this.transportCost || 0,
            personCost: this.personCost || 0,
            coatingCost: this.coatingCost || 0,
            certificationCost: this.certificationCost || 0,
            otherCost: this.otherCost || 0,
            discount: this.discount || 0,
            currency: this.currency,
            // note:this.purchaseTerms
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.toast("عملیات موفق", "success");
              router.push("/" + this.role + "/dashboard/");
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
          });
      }
    },
    draft() {
      this.toast("در حال ذخیره سازی... لطفا چند لحظه صبر کنید", "warning");
      Axios.post(
        this.baseUrl + "/ppkpms/order/draft",
        {
          orderId: this.$route.params.id,
          productsTemplate: this.formTemplate,
          measurementUnit: this.measurementUnit,
          customerTerms: this.newInfo.customerTerms
            ? this.newInfo.customerTerms
            : this.orderInfo.customerTerms,
          terms: this.newInfo.terms ? this.newInfo.terms : this.purchaseTerms,
          orderItems: JSON.stringify(this.orderInfo.orderItems),
          hasCustomerIndex: this.hasCustomerIndex,
          hasSizeStandard: this.hasSizeStandard,
          orderVat: this.orderVat || 0,
          packagingCost: this.packagingCost || 0,
          transportCost: this.transportCost || 0,
          personCost: this.personCost || 0,
          coatingCost: this.coatingCost || 0,
          certificationCost: this.certificationCost || 0,
          otherCost: this.otherCost || 0,
          discount: this.discount || 0,
          currency: this.currency,
          // note:this.purchaseTerms
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("پیش‌نویس با موفقیت ذخیره شد", "success");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    sarmadNumber(data) {
      if (data == "اشکالی در محاسبات وجود دارد. حاصل منفی شده است")
        return "اشکالی در محاسبات وجود دارد. حاصل منفی شده است";
      try {
        let temp1 = parseFloat(
          parseFloat(data).toFixed(
            this.currencyOptions.filter((x) => x.value == this.currency)[0]
              .precision
          )
        );
        return temp1 ? temp1 : 0;
      } catch (error) {
        return 0;
      }
    },
    addOffer() {
      this.orderInfo.orderItems.push({
        // totalPrice: "",
        perPrice: 0,
        number: 0,
        length: "",
        diameter: "",
        // dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        proposePerPrice: 0,
        // details: "",
        // customerIndex: ""
      });
    },
    delOffer(order) {
      this.orderInfo.orderItems.splice(order, 1);
    },
    delBatch(order) {
      this.batchData.splice(order, 1);
    },
    addItem(item) {
      this.orderInfo.orderItems.push({
        totalPrice: item.totalPrice,
        perPrice: item.perPrice,
        number: item.number,
        length: item.length,
        diameter: item.diameter,
        dimensionStandard: item.dimensionStandard,
        cover: item.cover,
        material: item.material,
        description: item.description,
        details: item.details,
        customerIndex: item.customerIndex,
        proposePerPrice: 0,
      });
    },
    copyItem(item, index) {
      this.orderInfo.orderItems.splice(index, 0, {
        totalPrice: item.totalPrice,
        perPrice: item.perPrice,
        number: item.number,
        length: item.length,
        diameter: item.diameter,
        dimensionStandard: item.dimensionStandard,
        cover: item.cover,
        material: item.material,
        description: item.description,
        details: item.details,
        customerIndex: item.customerIndex,
        proposePerPrice: 0,
      });
    },
    getPrice(item) {
      var priceFields = this.myFields;
      var myFilteredHistory = this.filteredHistory;
      priceFields = priceFields.filter((x) => x.key != "perPrice");
      priceFields = priceFields.filter((x) => x.key != "totalPrice");
      priceFields = priceFields.filter((x) => x.key != "operation");
      priceFields = priceFields.filter((x) => x.key != "details");
      priceFields = priceFields.filter((x) => x.key != "totalPrice");
      priceFields = priceFields.filter((x) => x.key != "number");
      priceFields = priceFields.filter((x) => x.key != "index");
      priceFields = priceFields.filter((x) => x.key != "customerIndex");
      priceFields = priceFields.map((x) => x.key);
      priceFields.forEach((thisField) => {
        try {
          myFilteredHistory = myFilteredHistory.filter(
            (x) =>
              x[thisField].toLowerCase().split(" ").join("") ==
              item[thisField].toLowerCase().split(" ").join("")
          );
        } catch (error) {
          console.log(item[thisField]);
        }
      });
      myFilteredHistory = myFilteredHistory.filter((x) => x.perPrice);
      if (myFilteredHistory.length) {
        item.perPrice = myFilteredHistory[0].perPrice;
        this.onlyChangePrice = !this.onlyChangePrice;
        this.onlyChangePrice = !this.onlyChangePrice;
      } else {
        item.perPrice = 0;
        alert("قیمت قبلی برای کالای مورد نظر پیدا نشد");
      }
    },
    getAllPrices() {
      this.vLoading = true;
      var counter = 0;
      var totalCount = this.orderInfo.orderItems.length;
      var priceFields = this.myFields;
      var myFilteredHistory = this.filteredHistory;
      priceFields = priceFields.filter((x) => x.key != "perPrice");
      priceFields = priceFields.filter((x) => x.key != "totalPrice");
      priceFields = priceFields.filter((x) => x.key != "operation");
      priceFields = priceFields.filter((x) => x.key != "details");
      priceFields = priceFields.filter((x) => x.key != "totalPrice");
      priceFields = priceFields.filter((x) => x.key != "number");
      priceFields = priceFields.filter((x) => x.key != "index");
      priceFields = priceFields.filter((x) => x.key != "customerIndex");
      priceFields = priceFields.map((x) => x.key);

      this.orderInfo.orderItems.forEach((item) => {
        try {
          myFilteredHistory = this.filteredHistory;
          priceFields.forEach((thisField) => {
            try {
              myFilteredHistory = myFilteredHistory.filter(
                (x) =>
                  x[thisField].toLowerCase().split(" ").join("") ==
                  item[thisField].toLowerCase().split(" ").join("")
              );
            } catch (error) {
              console.log(item[thisField]);
            }
          });

          myFilteredHistory = myFilteredHistory.filter((x) => x.perPrice);

          if (myFilteredHistory.length) {
            item.oldPerPrice = item.perPrice;
            item.perPrice = myFilteredHistory[0].perPrice;
            counter++;
            if (counter == totalCount) this.vLoading = false;
          } else {
            counter++;
            if (counter == totalCount) this.vLoading = false;
          }
        } catch (error) {
          counter++;
          if (counter == totalCount) this.vLoading = false;
        }
      });
    },
    batchAdd() {
      this.showBatchArea = !this.showBatchArea;
    },
    analyzeBatch() {
      let batchDataArray = this.batchText.split(",").join("").split("\n");
      if (this.hasSizeStandard) {
        if (this.hasCustomerIndex) {
          if (this.formTemplate == "pk1") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[10] ? x.split("\t")[10].trim() : "",
                perPrice: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                proposePerPrice: x.split("\t")[8]
                  ? x.split("\t")[8].trim()
                  : "",
                number: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                length: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                diameter: x.split("\t")[5]
                  ? x.split("\t")[5].replace(/\s+/g, " ").trim()
                  : "",
                dimensionStandard: x.split("\t")[4]
                  ? x.split("\t")[4].trim()
                  : "",
                cover: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                material: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsCI;
          } else if (this.formTemplate == "pk2") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                perPrice: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                proposePerPrice: x.split("\t")[5]
                  ? x.split("\t")[5].trim()
                  : "",
                number: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                length: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                diameter: x.split("\t")[2]
                  ? x.split("\t")[2].replace(/\s+/g, " ").trim()
                  : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields2CI;
          } else {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[10] ? x.split("\t")[10].trim() : "",
                perPrice: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                proposePerPrice: x.split("\t")[8]
                  ? x.split("\t")[8].trim()
                  : "",
                number: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                length: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                diameter: x.split("\t")[5]
                  ? x.split("\t")[5].replace(/\s+/g, " ").trim()
                  : "",
                dimensionStandard: x.split("\t")[4]
                  ? x.split("\t")[4].trim()
                  : "",
                cover: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                material: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsenCI;
          }
        } else {
          if (this.formTemplate == "pk1") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                proposePerPrice: x.split("\t")[7]
                  ? x.split("\t")[7].trim()
                  : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                dimensionStandard: x.split("\t")[3]
                  ? x.split("\t")[3].trim()
                  : "",
                cover: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                material: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields;
          } else if (this.formTemplate == "pk2") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                perPrice: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                proposePerPrice: x.split("\t")[4]
                  ? x.split("\t")[4].trim()
                  : "",
                number: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                length: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                diameter: x.split("\t")[1]
                  ? x.split("\t")[1].replace(/\s+/g, " ").trim()
                  : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields2;
          } else {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                proposePerPrice: x.split("\t")[7]
                  ? x.split("\t")[7].trim()
                  : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                dimensionStandard: x.split("\t")[3]
                  ? x.split("\t")[3].trim()
                  : "",
                cover: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                material: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsen;
          }
        }
      } else {
        if (this.hasCustomerIndex) {
          if (this.formTemplate == "pk1") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                proposePerPrice: x.split("\t")[7]
                  ? x.split("\t")[7].trim()
                  : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                cover: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                material: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsCI;
          } else if (this.formTemplate == "pk2") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                proposePerPrice: x.split("\t")[7]
                  ? x.split("\t")[7].trim()
                  : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields2CI;
          } else {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                proposePerPrice: x.split("\t")[7]
                  ? x.split("\t")[7].trim()
                  : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                cover: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                material: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsenCI;
          }
        } else {
          if (this.formTemplate == "pk1") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                perPrice: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                proposePerPrice: x.split("\t")[6]
                  ? x.split("\t")[6].trim()
                  : "",
                number: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                length: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                diameter: x.split("\t")[3]
                  ? x.split("\t")[3].replace(/\s+/g, " ").trim()
                  : "",
                cover: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                material: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields;
          } else if (this.formTemplate == "pk2") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                perPrice: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                proposePerPrice: x.split("\t")[6]
                  ? x.split("\t")[6].trim()
                  : "",
                number: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                length: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                diameter: x.split("\t")[3]
                  ? x.split("\t")[3].replace(/\s+/g, " ").trim()
                  : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields2;
          } else {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                perPrice: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                proposePerPrice: x.split("\t")[6]
                  ? x.split("\t")[6].trim()
                  : "",
                number: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                length: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                diameter: x.split("\t")[3]
                  ? x.split("\t")[3].replace(/\s+/g, " ").trim()
                  : "",
                cover: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                material: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsen;
          }
        }
      }

      this.showBatchTable = true;
    },
    delAnalyzeBatch() {
      this.batchData = [];
      this.showBatchTable = false;
    },
    doBatchAdd() {
      this.orderInfo.orderItems = this.orderInfo.orderItems.concat(
        this.batchData
      );
      this.batchText = "";
      this.batchData = [];
      this.showBatchTable = false;
      this.showBatchArea = false;
    },
    downloadCSV() {
      let a = document.createElement("a");
      let exportItems = this.items.map((item) => {
        return {
          perPrice: item.perPrice,
          number: item.number,
          length: item.length,
          diameter: item.diameter,
          dimensionStandard: item.dimensionStandard,
          cover: item.cover,
          material: item.material,
          description: item.description,
        };
      });
      a.href =
        "data:text/csv;charset=utf-8,\uFEFF" +
        encodeURIComponent(ConvertToCSV(JSON.stringify(exportItems)));
      a.download = "temp" + new Date() + ".csv";
      a.click();
    },

    extractOrderId() {
      const url = window.location.href;
      const segments = url.split("/");
      this.orderId = segments[segments.length - 1];
    },
    updatePurchaseTerms(value) {
      this.newInfo.terms = value;
    },
    togglePurchaseTerms() {
      this.showPurchaseTemrs = !this.showPurchaseTemrs;
    },
    handleButtonClickpurchas() {
      if (!this.showPurchaseTemrs) {
        this.submitEditPurchaseTerms();
      }
      this.togglePurchaseTerms();
    },
    submitEditPurchaseTerms() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/edit",
        {
          orderId: this.orderId,
          terms: this.newInfo.terms,
          note:
            "متن بالای استعلام ویرایش شد. <hr />متن قبلی: <br/>" +
            this.orderInfo.terms +
            "<hr/>متن جدید:<br/>" +
            this.newInfo.terms,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            this.getTaskInfo();
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    updateCustomerTerms(value) {
      this.newInfo.customerTerms = value;
    },
    toggleCustomerTerms() {
      this.showCustomerTerms = !this.showCustomerTerms;
    },
    handleButtonClick() {
      if (!this.showCustomerTerms) {
        this.submitEditCustomerTerms();
      }
      this.toggleCustomerTerms();
    },
    submitEditCustomerTerms() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/edit",
        {
          orderId: this.orderId,
          customerTerms: this.newInfo.customerTerms,
          note:
            "متن بالای استعلام ویرایش شد. <hr />متن قبلی: <br/>" +
            this.orderInfo.customerTerms +
            "<hr/>متن جدید:<br/>" +
            this.newInfo.customerTerms,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            this.getTaskInfo();
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    multiply() {
      this.orderInfo.orderItems.forEach((x) => {
        x.perPrice = this.sarmadNumber(
          x.perPrice * (1 + this.multiplier / 100)
        );
      });
      this.multiplier = 0;
    },
    multiplyCount() {
      this.orderInfo.orderItems.forEach((x) => {
        x.number = parseInt(x.number * (1 + this.multiplierCount / 100));
      });
      this.multiplierCount = 0;
    },
    delAll() {
      this.deleteDialog = true;
    },
    hideModal(name) {
      name = false;
    },
    doDelAll() {
      this.orderInfo.orderItems = [];
      this.deleteDialog = false;
    },
    editSelected() {
      this.editSelectedModal = true;
    },
    getTaskInfo() {
      this.vLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/office/order/query/getInfo",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.orderInfo = res.data;
            this.newInfo.customerTerms = this.orderInfo.customerTerms;
            this.newInfo.terms = this.orderInfo.terms;
            if (
              this.role == "Manager" ||
              this.role == "ceo" ||
              this.role == "salesManager"
            )
              this.getInventory();
            if (
              this.orderInfo.status == "تعیین قیمت توسط مدیر عامل" ||
              this.orderInfo.status == "بررسی تعیین قیمت توسط مدیر فروش" ||
              this.orderInfo.status == "آماده برای امضا" ||
              this.role == "ceo" ||
              this.role == "salesManager"
            )
              this.onlyChangePrice = true;
            this.formTemplate = this.orderInfo.productsTemplate || "pk1";
            this.measurementUnit = this.orderInfo.measurementUnit || "تعداد";
            this.currency = this.orderInfo.currency || "ریال";
            this.orderInfo.files = JSON.parse(this.orderInfo.files);
            this.customerTerms = this.orderInfo.customerTerms;
            this.purchaseTerms = this.orderInfo.terms;
            this.journals = this.orderInfo.history;
            this.packagingCost = this.orderInfo.packagingCost;
            this.transportCost = this.orderInfo.transportCost;
            this.personCost = this.orderInfo.personCost;
            this.coatingCost = this.orderInfo.coatingCost;
            this.certificationCost = this.orderInfo.certificationCost;
            this.otherCost = this.orderInfo.otherCost;
            this.discount = this.orderInfo.discount;
            this.orderVat = this.orderInfo.orderVat;
            this.hasSizeStandard = this.orderInfo.orderHasSizeStandard;
            this.hasCustomerIndex = this.orderInfo.hasCustomerIndex;
            this.orderInfo.orderItems
              ? (this.orderInfo.orderItems = JSON.parse(
                  this.orderInfo.orderItems
                ))
              : (this.orderInfo.orderItems = []);

            this.orderInfo.orderItems.forEach((item) => {
              item.perPrice = Number(item.perPrice);
              item.number = Number(item.number);
              item.proposePerPrice = Number(item.proposePerPrice);
            });
            this.selectedItems = new Array(
              this.orderInfo.orderItems.length
            ).fill(false);

            ///////////////////////////////////////////////////////////////
            ///// DEFINE TABLE COLUMSN DUE TO AVAILABLE INFORMATION ///////
            ///////////////////////////////////////////////////////////////

            ///////////////////////////////////////////////////////////////
            ///// DEFINE TABLE COLUMSN DUE TO AVAILABLE INFORMATION ///////
            ///////////////////////////////////////////////////////////////

            this.vLoading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    getCustomerHistory() {
      this.vLoading = true;

      Axios.post(
        this.baseUrl + "/ppkpms/customer/getInfo",
        { customerId: this.$route.params.customer },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.customerOrders = res.data.orders;
            this.ordersTotalRows = this.customerOrders.length;
            this.staticOrdersTotalRows = this.customerOrders.length;
            this.agents = res.data.contacts;
            this.agentsTotalRows = this.agents.length;
            this.staticAgentsTotalRows = this.agents.length;
            this.customer = res.data.customer;
            this.customerOrdersIsBusy = false;
            this.agentsIsBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });

      Axios.post(
        this.baseUrl + "/ppkpms/customer/ordersItems",
        {
          customerId: this.$route.params.customer,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.vLoading = false;
            this.customerHistory = res.data.filter(
              (x) => x.orderCode != this.orderInfo.orderCode
            );
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.toast(err.response.data, "error");
        });
    },
    upload() {},
    onBlur(evt) {},
    onFocus(evt) {},
    onContentDom(evt) {},
    onDialogDefinition(evt) {},
    onFileUploadRequest(evt) {},
    onFileUploadResponse(evt) {},
    toggleSelectAll() {
      this.vLoading = true;
      this.updateTableBusy = true;
      if (
        this.orderInfo.orderItems.length ==
        this.orderInfo.orderItems.filter((x) => x.selected).length
      )
        this.orderInfo.orderItems.forEach((element) => {
          element.selected = false;
        });
      else
        this.orderInfo.orderItems.forEach((element) => {
          element.selected = true;
        });

      setTimeout(() => {
        this.vLoading = false;
        this.updateTableBusy = false;
      }, 250);
    },
    syncUpdateTable() {
      this.updateTableBusy = true;
      setTimeout(() => {
        this.updateTableBusy = false;
      }, 250);
    },
    bulkUpdate() {
      this.vLoading = true;
      this.orderInfo.orderItems.forEach((item) => {
        if (item.selected) {
          this.myFields.forEach((field) => {
            if (this.updateAllItems[0][field.key]) {
              item[field.key] = this.updateAllItems[0][field.key];
            }
          });
        }
      });
      setTimeout(() => {
        this.vLoading = false;
      }, 250);
    },
    importPrpposePrice() {
      this.orderInfo.orderItems.forEach((item) => {
        item.perPrice =
          item.proposePerPrice > 0 ? item.proposePerPrice : item.perPrice;
      });
    },
    importPrpposePriceIndex(index) {
      this.orderInfo.orderItems[index].perPrice =
        this.orderInfo.orderItems[index].proposePerPrice > 0
          ? this.orderInfo.orderItems[index].proposePerPrice
          : this.orderInfo.orderItems[index].perPrice;
    },
  },

  computed: {
    myFields() {
      let myfields = [];

      myfields = this.hasCustomerIndex
        ? this.formTemplate == "pk1"
          ? this.fieldsCI
          : this.formTemplate == "pk2"
          ? this.fields2CI
          : this.formTemplate == "pken2"
          ? this.fieldsen2CI
          : this.fieldsenCI
        : this.formTemplate == "pk1"
        ? this.fields
        : this.formTemplate == "pk2"
        ? this.fields2
        : this.formTemplate == "pken2"
        ? this.fieldsen2
        : this.fieldsen;

      if (!this.hasSizeStandard) {
        myfields = myfields.filter((x) => x.key != "dimensionStandard");
      }

      if (this.orderInfo.orderType == "technical") {
        myfields = myfields.filter((x) => x.key != "perPrice");
        myfields = myfields.filter((x) => x.key != "totalPrice");
      }

      return myfields;
    },
    perPriceOptions() {
      let myOptions = {
        decimal: ".",
        thousands: ",",
        precision: 0,
      };
      try {
        myOptions = {
          decimal: ".",
          thousands: ",",
          precision: this.currencyOptions.filter(
            (x) => x.value == this.currency
          )[0].precision,
        };
      } catch (error) {
        myOptions = {
          decimal: ".",
          thousands: ",",
          precision: 0,
        };
      }
      return myOptions;
    },
    filtered() {
      const filtered = this.orderInfo.orderItems.filter((item) => {
        return Object.keys(this.filters).every((key) =>
          String(item[key])
            .toLowerCase()
            .includes(this.filters[key].toLowerCase())
        );
      });
      return filtered;
    },
    filteredHistory() {
      let filteredHistory;
      try {
        filteredHistory = this.customerHistory.filter((item) => {
          return Object.keys(this.filtersHistory).every((key) =>
            String(item[key])
              .toLowerCase()
              .includes(this.filtersHistory[key].toLowerCase())
          );
        });
      } catch (error) {
        filteredHistory = [];
      }
      return filteredHistory;
    },
    warehouseFilteredItems() {
      let filteredItems;
      try {
        filteredItems = this.warehouseItems.filter((item) => {
          return Object.keys(this.filtersWarehouse).every((key) =>
            String(item[key])
              .toLowerCase()
              .includes(this.filtersWarehouse[key].toLowerCase())
          );
        });
      } catch (error) {
        filteredItems = [];
      }
      return filteredItems;
    },
    // totalPriceVatExcluded() {
    //   let sarmadNumber = this.sarmadNumber;
    //   let temp1 =
    //     sarmadNumber(
    //       this.orderInfo.orderItems
    //         .map(
    //           (x) =>
    //             (x.perPrice ? String(x.perPrice).replace(/\s/g, "") : 0) *
    //             (x.number ? x.number.toString().replace(/\s/g, "") : 0)
    //         )
    //         .reduce((a, b) => a + b) - sarmadNumber(this.discount)
    //     ) +
    //     sarmadNumber(this.packagingCost) +
    //     sarmadNumber(this.transportCost) +
    //     sarmadNumber(this.personCost) +
    //     sarmadNumber(this.certificationCost) +
    //     sarmadNumber(this.otherCost);

    //   if (this.currency == "ریال") temp1 = Math.round(temp1 / 1) * 1;
    //   else if (this.currency == "Rials") temp1 = Math.round(temp1 / 1) * 1;
    //   else temp1 = temp1;

    //   if (temp1 >= 0) return temp1.toLocaleString() + " " + this.currency;
    //   else return "اشکالی در محاسبات وجود دارد. حاصل منفی شده است";
    // },
    // totalPrice() {
    //   let sarmadNumber = this.sarmadNumber;
    //   let temp1 =
    //     sarmadNumber(
    //       (this.orderInfo.orderItems
    //         .map(
    //           (x) =>
    //             (x.perPrice ? String(x.perPrice).replace(/\s/g, "") : 0) *
    //             (x.number ? x.number.toString().replace(/\s/g, "") : 0)
    //         )
    //         .reduce((a, b) => a + b) -
    //         sarmadNumber(this.discount)) *
    //         (1 + this.orderVat / 100)
    //     ) +
    //     sarmadNumber(this.packagingCost) +
    //     sarmadNumber(this.transportCost) +
    //     sarmadNumber(this.personCost) +
    //     sarmadNumber(this.certificationCost) +
    //     sarmadNumber(this.otherCost);

    //   if (this.currency == "ریال") temp1 = Math.round(temp1 / 1) * 1;
    //   else if (this.currency == "Rials") temp1 = Math.round(temp1 / 1) * 1;
    //   else temp1 = temp1;

    //   if (temp1 >= 0) return temp1.toLocaleString() + " " + this.currency;
    //   else return "اشکالی در محاسبات وجود دارد. حاصل منفی شده است";
    // },
  },
  mounted() {
    this.role = window.localStorage.getItem("role");
    this.getTaskInfo();
    this.getCustomerHistory();
    this.extractOrderId();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
textarea {
  padding: 2px !important;
}

hr {
  border: none;
  border-top: 3px double #333;
  color: #333;
  overflow: visible;
  text-align: center;
  height: 5px;
}

.VIP {
  background-color: rgb(150, 111, 13);
  color: white;
}

.معمولی {
  background-color: rgb(3, 25, 135);
  color: white;
}

.لیست {
  background-color: rgb(224, 10, 10);
  color: black;
}
</style>
